/* tslint:disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v11.17.2.0 (NJsonSchema v9.10.45.0 (Newtonsoft.Json v9.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import {EditableValue, IStateProperty} from 'src/components/BaseColumn';
import { ITextExportStatus } from 'src/components/Table/VirtualizedTableInterfaces';
import {BaseClient} from './BaseClient';

export interface IClient {
  /**
   * acts as main-entry-point to the application backend. Returns all sub-entrypoints for the single pages
   * @return OK
   */
  getBaseUsingGET(): Promise<SwaggerResponse<MenuDto>>;
  /**
   * acts as entry-point to the admin area. Returns all sub-entrypoints for the admin area pages
   * @return OK
   */
  getAdminAreaUsingGET(): Promise<SwaggerResponse<MenuDto>>;
  /**
   * returns the current application-state
   * @return OK
   */
  getStateUsingGET(): Promise<SwaggerResponse<string>>;
  /**
   * returns all possible columns for a PSL workflow
   * @return OK
   */
  getColumnsUsingGET(): Promise<SwaggerResponse<string[]>>;
  /**
   * returns the categories for standard options
   * @modelyear modelyear
   * @language language
   * @return OK
   */
  getCategoriesForStandardOptionUsingGET(
    modelyear: string,
    language: string
  ): Promise<SwaggerResponse<ResourceListOfCategoryTextDto>>;
  /**
   * returns all cnrs that are known in PSL
   * @metadata (optional) metadata
   * @return OK
   */
  getCnrsUsingGET(
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfCnrDto>>;
  /**
   * returns the basic market cnr
   * @return OK
   */
  getBasicMarketCnrUsingGET(): Promise<SwaggerResponse<CnrDto>>;
  /**
   * converts plain text into HTML formatted text
   * @textToConvert textToConvert
   * @return OK
   */
  convertToHTMLUsingPOST(
    textToConvert: string
  ): Promise<SwaggerResponse<string>>;
  /**
   * error
   * @return OK
   */
  errorUsingGET(): Promise<SwaggerResponse<{ [key: string]: any }>>;
  /**
   * error
   * @return OK
   */
  errorUsingHEAD(): Promise<SwaggerResponse<{ [key: string]: any }>>;
  /**
   * error
   * @return OK
   */
  errorUsingPOST(): Promise<SwaggerResponse<{ [key: string]: any }>>;
  /**
   * error
   * @return OK
   */
  errorUsingPUT(): Promise<SwaggerResponse<{ [key: string]: any }>>;
  /**
   * error
   * @return OK
   */
  errorUsingDELETE(): Promise<SwaggerResponse<{ [key: string]: any }>>;
  /**
   * error
   * @return OK
   */
  errorUsingOPTIONS(): Promise<SwaggerResponse<{ [key: string]: any }>>;
  /**
   * error
   * @return OK
   */
  errorUsingPATCH(): Promise<SwaggerResponse<{ [key: string]: any }>>;
  /**
   * logging frontend error
   * @error error
   * @return OK
   */
  logErrorUsingPOST(error: FrontendError): Promise<SwaggerResponse<string>>;
  /**
   * exports options based on filters
   * @optionFilterDto optionFilterDto
   * @return OK
   */
  exportOptionsUsingPOST(
    optionFilterDto: OptionFilterDto
  ): Promise<SwaggerResponse<ExcelExportResponseDto>>;
  /**
   * exports options to an excel file
   * @excelPropsDto excelPropsDto
   * @return OK
   */
  exportOptionsV2UsingPOST(
    excelPropsDto: ExcelPropsDto
  ): Promise<SwaggerResponse<ExcelExportResponseDto>>;
  /**
   * downloads excel file(identified by name) from the server
   * @fileName fileName
   * @return OK
   */
  downloadExcelV2UsingGET(
    fileName: string
  ): Promise<SwaggerResponse<ExcelDownloadResponseDto>>;
  /**
   * downloads excel file, given by name, from the server
   * @fileName fileName
   * @return OK
   */
  downloadExcelUsingGET(
    fileName: string
  ): Promise<SwaggerResponse<ExcelDownloadResponseDto>>;
  /**
   * triggers the options texts export process from ProMT to PSL- only for tests!
   * @return OK
   */
  triggerOptionsTextsExportUsingGET(): Promise<SwaggerResponse<void>>;
  /**
   * returns all groups that are known in PSL
   * @metadata (optional) metadata
   * @return OK
   */
  getGroupsUsingGET(
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfGroupDto>>;
  /**
   * creates a new group in PSL
   * @group group
   * @return OK
   */
  addGroupUsingPOST(group: GroupDto): Promise<SwaggerResponse<Link>>;
  /**
   * delete an existing group in PSL
   * @group group
   * @return group was deleted succesfully
   */
  deleteGroupUsingDELETE(group: GroupDto): Promise<SwaggerResponse<any>>;
  /**
   * updates an existing group in PSL
   * @group group
   * @return group was updated succesfully
   */
  updateGroupUsingPATCH(group: GroupDto): Promise<SwaggerResponse<Link>>;
  /**
   * Gets all direct parent groups for a user.
   * @userCn userCn
   * @return groups were found succesfully
   */
  getDirectParentGroupsUsingGET(
    userCn: string
  ): Promise<SwaggerResponse<ResourceListOfGroupDto>>;
  /**
   * Gets all indirect parent groups for a user.
   * @userCn userCn
   * @return groups were found succesfully
   */
  getIndirectParentGroupsUsingGET(
    userCn: string
  ): Promise<SwaggerResponse<ResourceListOfGroupDto>>;
  /**
   * get group details from LDAP
   * @groupName groupName
   * @return returns the detailed group-info from LDAP
   */
  getGroupLdapDetailsUsingGET(
    groupName: string
  ): Promise<SwaggerResponse<GroupDetailsDto>>;
  /**
   * get a single group by given id
   * @id id
   * @metadata (optional) metadata
   * @return returns a group identified by given id
   */
  findGroupByIdUsingGET(
    id: number,
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<GroupDto>>;
  /**
   * triggers the category import process - only for tests!
   * @return OK
   */
  triggerCategoryImportUsingGET(): Promise<SwaggerResponse<void>>;
  /**
   * returns all importers that are known in PSL
   * @metadata (optional) metadata
   * @return OK
   */
  getImportersUsingGET(
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfImporterDto>>;
  /**
   * returns the init-data for the UI for a given user
   * @cn cn
   * @return OK
   */
  getInitDataUsingGET(cn: string): Promise<SwaggerResponse<InitDto>>;
  /**
   * returns all labels for a specific language code and namespace
   * @languageCode languageCode
   * @namespace namespace
   * @return returns all labels for a specific language code
   */
  findAllByLanguageCodeUsingGET(
    languageCode: string,
    namespace: string
  ): Promise<SwaggerResponse<string>>;
  /**
   * returns all languages that are known in PSL
   * @metadata (optional) metadata
   * @return OK
   */
  getLanguagesUsingGET(
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfLanguageDto>>;
  /**
   * creates a new modeltype basic in PSL
   * @modeltypeBasic modeltypeBasic
   * @return OK
   */
  saveModeltypeBasicUsingPOST(
    modeltypeBasic: ModeltypeBasicDto
  ): Promise<SwaggerResponse<Link>>;
  /**
   * delete an existing modeltypebasic in PSL
   * @modeltypeBasic modeltypeBasic
   * @return OK
   */
  deleteModeltypeBasicUsingDELETE(
    modeltypeBasic: ModeltypeBasicDto
  ): Promise<SwaggerResponse<any>>;
  /**
   * updates an existing modeltype basic in PSL
   * @modeltypeBasic modeltypeBasic
   * @return modeltype basic was updated succesfully
   */
  updateModeltypeBasicUsingPATCH(
    modeltypeBasic: ModeltypeBasicDto
  ): Promise<SwaggerResponse<Link>>;
  /**
   * returns the list of colors for modeltypes
   * @return returns the list of colors for modeltypes
   */
  getModeltypeBasicColorsUsingGET(): Promise<SwaggerResponse<string[]>>;
  /**
   * copies modeltype basics of the same typefamily from one modelyear to another
   * @modeltypeBasicCopyDto modeltypeBasicCopyDto
   * @return OK
   */
  copyModeltypeBasicsUsingPOST(
    modeltypeBasicCopyDto: ModeltypeBasicCopyDto
  ): Promise<SwaggerResponse<Link>>;
  /**
   * get PDiP modeltype basic data based on model year
   * @mj4 mj4
   * @return OK
   */
  getPDiPMTBsByModelyearUsingGET(
    mj4: number
  ): Promise<SwaggerResponse<PDiPModeltypebasicDto[]>>;
  /**
   * returns a single modeltype basic by given id
   * @id id
   * @metadata (optional) metadata
   * @return returns a option basic identified by given id
   */
  getModeltypeBasicUsingGET(
    id: number,
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ModeltypeBasicDto>>;
  /**
   * get the derivate psl connections
   * @id id
   * @return OK
   */
  getModeltypeBasicPslConnectionsUsingGET(
    id: number
  ): Promise<SwaggerResponse<{ [key: string]: number }>>;
  /**
   * returns all modelyears that are known in PSL
   * @metadata (optional) metadata
   * @return OK
   */
  getModelyearsUsingGET(
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfModelyearDto>>;
  /**
   * returns a single modelyear
   * @id id
   * @metadata (optional) metadata
   * @return OK
   */
  getModelyearByIdUsingGET(
    id: number,
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ModelyearDto>>;
  /**
   * get PDiP option basic data based on model year
   * @mj4 mj4
   * @return OK
   */
  getPDiPOBsByModelyearUsingGET(
    mj4: number
  ): Promise<SwaggerResponse<PDiPOptionBasicDto[]>>;
  /**
   * creates a new option basic in PSL
   * @optionBasic optionBasic
   * @return OK
   */
  addOptionBasicUsingPOST(
    optionBasic: OptionBasicDto
  ): Promise<SwaggerResponse<OptionBasicDto>>;
  /**
   * deletes an existing option basic in PSL
   * @optionBasic optionBasic
   * @return OK
   */
  deleteOptionBasicUsingDELETE(
    optionBasic: OptionBasicDto
  ): Promise<SwaggerResponse<Link>>;
  /**
   * updates an existing option basic in PSL
   * @optionBasic optionBasic
   * @return option basic was updated succesfully
   */
  updateOptionBasicUsingPATCH(
    optionBasic: OptionBasicDto
  ): Promise<SwaggerResponse<Link>>;
  /**
   * copies existing option basics of one modelyear to another
   * @copyDto copyDto
   * @return OK
   */
  copyModelYearOptionBasicsUsingPOST(
    copyDto: OptionBasicMYCopyDto
  ): Promise<SwaggerResponse<OptionBasicMYCopySummaryDto>>;
  /**
   * returns the copy conflict status for the source context data
   * @sourceModelyearId sourceModelyearId
   * @targetModelyearId targetModelyearId
   * @return Option basic modelyear copy conflict status returned.
   */
  getOptionBasicMYCopyConflictStatusUsingGET(
    sourceModelyearId: number,
    targetModelyearId: number
  ): Promise<SwaggerResponse<OptionBasicMYCopyConflictDto[]>>;
  /**
   * gets PSL contexts dependencies for option basics
   * @optionBasicIds optionBasicIds
   * @return OK
   */
  getOptionBasicDeleteDependenciesUsingGET(
    optionBasicIds: number[]
  ): Promise<SwaggerResponse<{ [key: string]: OptionBasicPSLDependencyDto }>>;
  /**
   * returns extra endpoints for the base options page
   * @return OK
   */
  getOptionBasicAreaExtraLinksUsingGET(): Promise<SwaggerResponse<MenuDto>>;
  /**
   * returns a map with the base option id as key and as value a status, whether the OB can be initialized or not( based on OB, C number and type family
   * @typeFamily typeFamily
   * @optionBasicDtoIds optionBasicDtoIds
   * @return OK
   */
  getOptionBasicInitStatusUsingGET(
    typeFamily: number,
    optionBasicDtoIds: number[]
  ): Promise<SwaggerResponse<{ [key: string]: boolean }>>;
  /**
   * returns a single option basic by given id
   * @id id
   * @metadata (optional) metadata
   * @return returns a option basic identified by given id
   */
  getOptionBasicUsingGET(
    id: number,
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<OptionBasicDto>>;
  /**
   * creates a new BM option or a specific option of type EOptionSpecificType.COPY based on a template option
   * @simpleOptionCopyDto simpleOptionCopyDto
   * @return OK
   */
  copyOptionUsingPOST(
    simpleOptionCopyDto: SimpleOptionCopyDto
  ): Promise<SwaggerResponse<Link>>;
  /**
   * deletes an existing option
   * @dto dto
   * @return OK
   */
  deleteOptionUsingDELETE(dto: OptionDto): Promise<SwaggerResponse<Link>>;
  /**
   * updates an existing option
   * @dto dto
   * @return Option was updated succesfully
   */
  updateOptionUsingPATCH(dto: OptionUpdateDto): Promise<SwaggerResponse<Link>>;
  /**
   * returns an option for the given parent id
   * @parentId parentId
   * @return OK
   */
  getOptionByParentIdUsingGET(
    parentId: number
  ): Promise<SwaggerResponse<OptionDto[]>>;
  /**
   * returns the differences between a given specific market option and its parent basic market option
   * @childId childId
   * @return OK
   */
  getDifferencesUsingGET(
    childId: number
  ): Promise<SwaggerResponse<OptionDifferenceDto>>;
  /**
   * updates the constraint values for an existing option
   * @dto dto
   * @return OK
   */
  updateOptionConstraintUsingPATCH(
    dto: OptionDto
  ): Promise<SwaggerResponse<Link>>;
  /**
   * copies existing PSL contexts to target contexts
   * @sourceModelyearId sourceModelyearId
   * @sourceTypefamilyId sourceTypefamilyId
   * @targetModelyearId targetModelyearId
   * @targetTypefamilyId targetTypefamilyId
   * @return OK
   */
  copyPSLContextsUsingPOST(
    sourceModelyearId: number,
    sourceTypefamilyId: number,
    targetModelyearId: number,
    targetTypefamilyId: number
  ): Promise<SwaggerResponse<PSLCopyResultSummaryDto>>;
  /**
   * updates the exclusion for an existing option
   * @dto dto
   * @return OK
   */
  updateOptionExclusionUsingPATCH(
    dto: OptionDto
  ): Promise<SwaggerResponse<Link>>;
  /**
   * returns extra endpoints for the PSL page
   * @return OK
   */
  getPSLAreaExtraLinksUsingGET(): Promise<SwaggerResponse<MenuDto>>;
  /**
   * updates the modeltypeBasic assignments for an existing option
   * @optionDto optionDto
   * @return OK
   */
  updateOptionModeltypeBasicAssignmentsUsingPATCH(
    optionDto: OptionDto
  ): Promise<SwaggerResponse<Link>>;
  /**
   * update the workflow status of options based on an action type
   * @reqBody reqBody
   * @return OK
   */
  multiUpdateOptionsWorkflowStatusUsingPATCH(
    reqBody: OptionWorkflowStatusMultiUpdateParam
  ): Promise<SwaggerResponse<number>>;
  /**
   * deletes a list of options
   * @optionDtos optionDtos
   * @return OK
   */
  multiDeleteOptionsUsingPATCH(
    optionDtos: DtoListWithLinksOfOptionDto
  ): Promise<SwaggerResponse<number[]>>;
  /**
   * updates the package content for an existing option
   * @dto dto
   * @return OK
   */
  updateOptionPackageContentUsingPATCH(
    dto: OptionDto
  ): Promise<SwaggerResponse<Link>>;
  /**
   * return the conflicts between two psl contexts
   * @sourceModelyearId sourceModelyearId
   * @sourceTypefamilyId sourceTypefamilyId
   * @targetModelyearId targetModelyearId
   * @targetTypefamilyId targetTypefamilyId
   * @return PSL context copy conflicts returned.
   */
  getPSLCopyConflictsUsingGET(
    sourceModelyearId: number,
    sourceTypefamilyId: number,
    targetModelyearId: number,
    targetTypefamilyId: number
  ): Promise<SwaggerResponse<PSLCopyConflictDto[]>>;
  /**
   * returns data for cnrs that contain options for the search context and the count
   * @modelyearId modelyearId
   * @typefamilyId typefamilyId
   * @return OK
   */
  getPSLStatsUsingGET(
    modelyearId: number,
    typefamilyId: number
  ): Promise<SwaggerResponse<{ [key: string]: number }>>;
  /**
   * resets the workflow for an existing option
   * @dto dto
   * @return Option workflow was reset successfuly!
   */
  resetOptionWorkflowUsingPATCH(dto: OptionDto): Promise<SwaggerResponse<Link>>;
  /**
   * Creates specific option / options from a list of specific market options
   * @initSpecificOptionDto initSpecificOptionDto
   * @return OK
   */
  initSpecificMarketOptionsUsingPOST(
    initSpecificOptionDto: SpecificOptionInitDto
  ): Promise<SwaggerResponse<ResourceListOfOptionDto>>;
  /**
   * updates a specific option of type DEPENDENT_OVERWRITE to INDEPENDENT_OVERWRITE
   * @optionId optionId
   * @return OK
   */
  createIndependentOverwriteSpecificOptionUsingPATCH(
    optionId: number
  ): Promise<SwaggerResponse<Link>>;
  /**
   * updates the texts assignments for an existing option
   * @optionDto optionDto
   * @return OK
   */
  updateOptionTextsUsingPATCH(
    optionDto: OptionDto
  ): Promise<SwaggerResponse<Link>>;
  /**
   * transfer/update of derivate assignments for options
   * @dto dto
   * @return OK
   */
  transferOptionAssignmentsUsingPATCH(
    dto: AssignmentTransferDto
  ): Promise<SwaggerResponse<{ [key: string]: string }>>;
  /**
   * returns an option for the given id
   * @optionId optionId
   * @metadata (optional) metadata
   * @return OK
   */
  getOptionByIdUsingGET(
    optionId: number,
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<OptionDto>>;
  /**
   * return the modeltypeBasics that are already assigned to an option's family
   * @optionId optionId
   * @cnrId cnrId
   * @return OK
   */
  getModeltypeBasicAssignmentsConflictsForCopyUsingGET(
    optionId: number,
    cnrId: number
  ): Promise<SwaggerResponse<{ [key: string]: string[] }>>;
  /**
   * return the modeltypeBasics that cannot be used because they are already assigned to the option's family
   * @optionId optionId
   * @return OK
   */
  getModeltypeBasicAssignmentsConflictsForUpdateUsingGET(
    optionId: number
  ): Promise<SwaggerResponse<{ [key: string]: string[] }>>;
  /**
   * creates a new PSL
   * @optionInitDto optionInitDto
   * @return OK
   */
  createOptionWithContextUsingPOST(
    optionInitDto: OptionInitDto
  ): Promise<SwaggerResponse<{ [key: string]: string }>>;
  /**
   * Returns all cnrs available in ProMT
   * @return Request was processed succesfully, data is returned.
   */
  getAllCnrsUsingGET(): Promise<SwaggerResponse<CnrExtDto[]>>;
  /**
   * Returns all active modeltypeBasic/derivates that are in PSL and have BTYP!=null.
   * @modelyear modelyear
   * @return Request was processed succesfully, data is returned.
   */
  getModeltypeBasicForUsingGET(
    modelyear: string
  ): Promise<SwaggerResponse<ModeltypeBasicExtDto[]>>;
  /**
   * Returns all model years available in ProMT
   * @return Request was processed succesfully, data is returned.
   */
  getAllModelyearsUsingGET(): Promise<SwaggerResponse<ModelyearExtDto[]>>;
  /**
   * Returns all approved basic options that are in ProMT and have option code not null.
   * @modelyear modelyear
   * @return Request was processed succesfully, data is returned.
   */
  getOptionBasicsForUsingGET(
    modelyear: string
  ): Promise<SwaggerResponse<OptionBasicExtDto[]>>;
  /**
   * Returns all typefamilies available in ProMT
   * @return Request was processed succesfully, data is returned.
   */
  getAllTypefamiliesUsingGET(): Promise<SwaggerResponse<TypefamilyExtDto[]>>;
  /**
   * returns all importers that are mapped in PSL to the given context
   * @modelyear modelyear
   * @btyp btyp
   * @pCCD_TECH_ID PCCD_TECH_ID
   * @payload payload
   * @return OK
   */
  getImporterMappingForUsingPOST(
    modelyear: string,
    btyp: string,
    pCCD_TECH_ID: string,
    payload: ImporterExtDto[]
  ): Promise<SwaggerResponse<ImporterExtDto[]>>;
  /**
   * returns the current monitoring-path
   * @return OK
   */
  getMonitoringPathUsingGET(): Promise<SwaggerResponse<string>>;
  /**
   * get priveleges
   * @metadata (optional) metadata
   * @return OK
   */
  getPrivelegesUsingGET(
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfPrivilegeDto>>;
  /**
   * check if a PSL is complete based on PCCD data
   * @modelyearId modelyearId
   * @typefamilyId typefamilyId
   * @cnrId cnrId
   * @return OK
   */
  checkPSLandPCCDSynchronisationUsingGET(
    modelyearId: number,
    typefamilyId: number,
    cnrId: number
  ): Promise<SwaggerResponse<MissingAssignmentsAndDerivateDTO>>;
  /**
   * get all roles
   * @metadata (optional) metadata
   * @return OK
   */
  findAllUsingGET(
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfRoleDto>>;
  /**
   * creates a new role in PSL
   * @role role
   * @return OK
   */
  saveRoleUsingPOST(role: RoleDto): Promise<SwaggerResponse<Link>>;
  /**
   * delete an existing role in PSL
   * @role role
   * @return role was deleted succesfully
   */
  deleteRoleUsingDELETE(role: RoleDto): Promise<SwaggerResponse<any>>;
  /**
   * updates an existing group in PSL
   * @role role
   * @return role was updated succesfully
   */
  updateRoleUsingPATCH(role: RoleDto): Promise<SwaggerResponse<Link>>;
  /**
   * get a single role by given id
   * @id id
   * @metadata (optional) metadata
   * @return returns a role identified by given id
   */
  findByIdUsingGET(
    id: number,
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<RoleDto>>;
  /**
   * returns all possible spec configurations
   * @return OK
   */
  getAllSpecsUsingGET(): Promise<
    SwaggerResponse<ResourceListOfSpecConfigurationDto>
  >;
  /**
   * creates a new spec configuration
   * @dto dto
   * @return OK
   */
  saveSpecConfigurationUsingPOST(
    dto: SpecConfigurationDto
  ): Promise<SwaggerResponse<Link>>;
  /**
   * deletes an existing spec configuration
   * @dto dto
   * @return OK
   */
  deleteSpecConfigurationUsingDELETE(
    dto: SpecConfigurationDto
  ): Promise<SwaggerResponse<any>>;
  /**
   * updates an existing spec configuration
   * @dto dto
   * @return spec configuration was updated successfully
   */
  updateSpecConfigurationUsingPATCH(
    dto: SpecConfigurationDto
  ): Promise<SwaggerResponse<Link>>;
  /**
   * returns a spec configuration with the given ID
   * @id id
   * @return Spec configuration with given ID was found
   */
  getSpecConfigByIdUsingGET(
    id: number
  ): Promise<SwaggerResponse<SpecConfigurationDto>>;
  /**
   * returns a list with all specs
   * @metadata (optional) metadata
   * @return request was successfully completed
   */
  getAllSpecsUsingGET_1(
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfSpecDto>>;
  /**
   * create a new spec
   * @spec spec
   * @return OK
   */
  createSpecUsingPOST(spec: SpecDto): Promise<SwaggerResponse<Link>>;
  /**
   * delete spec
   * @spec spec
   * @return OK
   */
  deleteSpecUsingDELETE(spec: SpecDto): Promise<SwaggerResponse<Link>>;
  /**
   * update a spec
   * @spec spec
   * @return OK
   */
  updateSpecUsingPATCH(spec: SpecDto): Promise<SwaggerResponse<Link>>;
  /**
   * get a single spec by given id
   * @id id
   * @metadata (optional) metadata
   * @return returns a spec identified by given id
   */
  findByIdUsingGET_1(
    id: number,
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<SpecDto>>;
  /**
   * acts as entry-point to the support area. Returns all sub-entrypoints for the support area pages
   * @return OK
   */
  getSupportAreaUsingGET(): Promise<SwaggerResponse<MenuDto>>;
  /**
   * returns all technical data from PCCD for the given context
   * @cnr cnr
   * @btyp btyp
   * @modelyear modelyear
   * @return OK
   */
  getTechnicalDataUsingGET(
    cnr: string,
    btyp: string,
    modelyear: string
  ): Promise<SwaggerResponse<TechnicalDataDto[]>>;
  /**
   * returns all typefamilies that are known in PSL for the given modelyear
   * @modelyearId modelyearId
   * @metadata (optional) metadata
   * @return OK
   */
  getTypeFamiliesUsingGET(
    modelyearId: number,
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfTypefamilyDto>>;
  /**
   * returns all user that are known in PSL
   * @metadata (optional) metadata
   * @return request was successfully completed
   */
  getUsersUsingGET(
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfUserDto>>;
  /**
   * creates a new user in PSL
   * @user user
   * @return OK
   */
  addUserUsingPOST(user: UserDto): Promise<SwaggerResponse<Link>>;
  /**
   * delete an existing user in PSL
   * @user user
   * @return user was deleted succesfully
   */
  deleteUserUsingDELETE(user: UserDto): Promise<SwaggerResponse<any>>;
  /**
   * updates an existing user in PSL
   * @user user
   * @return user was updated succesfully
   */
  updateUserUsingPATCH(user: UserDto): Promise<SwaggerResponse<Link>>;
  /**
   * get optionTypes available ofr a user from the groups that he is assigned to.
   * @cn cn
   * @return returns the list of option types from the user groups
   */
  getUserGroupsOptionTypesUsingGET(
    cn: string
  ): Promise<SwaggerResponse<Anonymous[]>>;
  /**
   * fetches all roles (user roles + user group roles) for a given user.
   * @userCn userCn
   * @return returns a list with all possible roles for the given user.
   */
  getAllRolesForUserUsingGET(
    userCn: string
  ): Promise<SwaggerResponse<RoleDto[]>>;
  /**
   * updates the user-settings for an existing user
   * @user user
   * @return user was updated succesfully
   */
  updateUserSettingsUsingPATCH(user: UserDto): Promise<SwaggerResponse<Link>>;
  /**
   * returns a single user
   * @cn cn
   * @metadata (optional) metadata
   * @return request was successfully completed
   */
  getUserUsingGET(
    cn: string,
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<UserDto>>;
  /**
   * get user details from LDAP
   * @cn cn
   * @return returns the detailed user-info from LDAP
   */
  getUserLdapDetailsUsingGET(
    cn: string
  ): Promise<SwaggerResponse<UserDetailsDto>>;
  /**
   * returns a list with all specs
   * @return request was successfully completed
   */
  getVersionInfoUsingGET(): Promise<SwaggerResponse<VersionInfoDto>>;
  /**
   * returns a list with all workflows
   * @metadata (optional) metadata
   * @return request was successfully completed
   */
  getAllWorkflowsUsingGET(
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfWorkflowDto>>;
  /**
   * creates a new workflow
   * @workflow workflow
   * @return OK
   */
  addWorkflowUsingPOST(workflow: WorkflowDto): Promise<SwaggerResponse<Link>>;
  /**
   * delete an existing workflow in PSL
   * @workflow workflow
   * @return OK
   */
  deleteWorkflowUsingDELETE(
    workflow: WorkflowDto
  ): Promise<SwaggerResponse<any>>;
  /**
   * updates an existing workflow
   * @workflow workflow
   * @return workflow was updated succesfully
   */
  updateWorkflowUsingPATCH(
    workflow: WorkflowDto
  ): Promise<SwaggerResponse<Link>>;
  /**
   * returns a list with all workflow-groups that can be approved for the current user
   * @return request was successfully completed
   */
  getAllWorkflowApprovalsUsingGET(): Promise<
    SwaggerResponse<ResourceListOfWorkflowOptionApprovalDto>
  >;
  /**
   * processes the given data and performs the next workflow-steps
   * @approvals approvals
   * @return OK
   */
  processWorkflowApprovalsUsingPOST(
    approvals: WorkflowOptionApprovalDto[]
  ): Promise<SwaggerResponse<any>>;
  /**
   * sendReleventApprovalsEmail
   * @return OK
   */
  sendReleventApprovalsEmailUsingGET(): Promise<SwaggerResponse<any>>;
  /**
   * empties the cache
   * @return OK
   */
  clearCacheUsingDELETE(): Promise<SwaggerResponse<any>>;
  /**
   * returns a map with the base option id as key and the corresponding available workflows as value
   * @typeFamily typeFamily
   * @optionBasicDtoIds optionBasicDtoIds
   * @return OK
   */
  getAvailableWorkflowsForOptionsUsingGET(
    typeFamily: number,
    optionBasicDtoIds: number[]
  ): Promise<SwaggerResponse<{ [key: string]: WorkflowDto[] }>>;
  /**
   * returns a list with all partitions that are relevant for the given workflow-type
   * @workflowType workflowType
   * @return request was successfully completed
   */
  getWorkflowPartitionsUsingGET(
    workflowType: WorkflowType
  ): Promise<SwaggerResponse<string[]>>;
  /**
   * returns a single workflow
   * @id id
   * @metadata (optional) metadata
   * @return request was successfully completed
   */
  getWorkflowByIdUsingGET(
    id: number,
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<WorkflowDto>>;
  /**
   * returns a list of options for the given context
   * @modelyearId modelyearId
   * @typefamilyId typefamilyId
   * @cnrId cnrId
   * @metadata (optional) metadata
   * @return OK
   */
  getOptionsUsingGET(
    modelyearId: number,
    typefamilyId: number,
    cnrId: number,
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfOptionDto>>;
  /**
   * get all active modeltype basics by modelyear
   * @modelyear modelyear
   * @typeFamilyId (optional) typeFamilyId
   * @computePdipFlag (optional) computePdipFlag
   * @metadata (optional) metadata
   * @return returns modeltype basics for specified modelyear (and/or typefamily).
   */
  getModeltypeBasicsUsingGET(
    modelyear: number,
    typeFamilyId?: number | null | undefined,
    computePdipFlag?: boolean | null | undefined,
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfModeltypeBasicDto>>;
  /**
   * get option basics by modelyear
   * @modelyear modelyear
   * @metadata (optional) metadata
   * @computePdipFlag (optional) computePdipFlag
   * @computePCCDFlag (optional) computePCCDFlag
   * @return returns option basics for specified modelyear
   */
  getByModelyearUsingGET(
    modelyear: number,
    metadata?: boolean | null | undefined,
    computePdipFlag?: boolean | null | undefined,
    computePCCDFlag?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfOptionBasicDto>>;
  /**
   * get option basics by modelyear that have an approved state
   * @modelyear modelyear
   * @metadata (optional) metadata
   * @return returns option basics for specified modelyear
   */
  getApprovedByModelyearUsingGET(
    modelyear: number,
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfOptionBasicDto>>;
  /**
   * get all active modeltype basics by modelyear and typefamily
   * @modelyear modelyear
   * @typeFamilyId typeFamilyId
   * @cnrId cnrId
   * @return returns modeltype basics for specified modelyear and typefamily
   */
  getModeltypeBasicsForPSLUsingGET(
    modelyear: number,
    typeFamilyId: number,
    cnrId: number
  ): Promise<SwaggerResponse<ResourceListOfModeltypeBasicDto>>;
  getOptionTypeUsingId(id:string): Promise<any>;
}

export class Client extends BaseClient implements IClient {
  private http: {
    fetch(url: RequestInfo, init?: RequestInit): Promise<Response>;
  };
  private baseUrl: string;
  protected jsonParseReviver: ((key: string, value: any) => any) | undefined =
    undefined;

  constructor(
    baseUrl?: string,
    http?: { fetch(url: RequestInfo, init?: RequestInit): Promise<Response> }
  ) {
    super();
    this.http = http ? http : <any>window;
    this.baseUrl = baseUrl ? baseUrl : 'http://localhost:8080/PSL/api';
  }

  /**
   * acts as main-entry-point to the application backend. Returns all sub-entrypoints for the single pages
   * @return OK
   */
  getBaseUsingGET(): Promise<SwaggerResponse<MenuDto>> {
    let url_ = this.baseUrl + '/';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetBaseUsingGET(_response)
        );
      });
  }

  protected processGetBaseUsingGET(
    response: Response
  ): Promise<SwaggerResponse<MenuDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <MenuDto>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<MenuDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  getOptionTypeUsingId(id:string): Promise<any> {
    let url_ = this.baseUrl + `/optionBasics/${id}/optionType`;
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetBaseUsingGET(_response)
        );
      });
  }
  /**
   * acts as entry-point to the admin area. Returns all sub-entrypoints for the admin area pages
   * @return OK
   */
  getAdminAreaUsingGET(): Promise<SwaggerResponse<MenuDto>> {
    let url_ = this.baseUrl + '/adminarea';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetAdminAreaUsingGET(_response)
        );
      });
  }

  protected processGetAdminAreaUsingGET(
    response: Response
  ): Promise<SwaggerResponse<MenuDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <MenuDto>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<MenuDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns the current application-state
   * @return OK
   */
  getStateUsingGET(): Promise<SwaggerResponse<string>> {
    let url_ = this.baseUrl + '/aliveCheck';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetStateUsingGET(_response)
        );
      });
  }

  protected processGetStateUsingGET(
    response: Response
  ): Promise<SwaggerResponse<string>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <string>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<string>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns all possible columns for a PSL workflow
   * @return OK
   */
  getColumnsUsingGET(): Promise<SwaggerResponse<string[]>> {
    let url_ = this.baseUrl + '/basecolumns';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetColumnsUsingGET(_response)
        );
      });
  }

  protected processGetColumnsUsingGET(
    response: Response
  ): Promise<SwaggerResponse<string[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<string[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns the categories for standard options
   * @modelyear modelyear
   * @language language
   * @return OK
   */
  getCategoriesForStandardOptionUsingGET(
    modelyear: string,
    language: string
  ): Promise<SwaggerResponse<ResourceListOfCategoryTextDto>> {
    let url_ = this.baseUrl + '/categories/standard?';
    if (modelyear === undefined || modelyear === null)
      throw new Error(
        "The parameter 'modelyear' must be defined and cannot be null."
      );
    else url_ += 'modelyear=' + encodeURIComponent('' + modelyear) + '&';
    if (language === undefined || language === null)
      throw new Error(
        "The parameter 'language' must be defined and cannot be null."
      );
    else url_ += 'language=' + encodeURIComponent('' + language) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetCategoriesForStandardOptionUsingGET(_response)
        );
      });
  }

  protected processGetCategoriesForStandardOptionUsingGET(
    response: Response
  ): Promise<SwaggerResponse<ResourceListOfCategoryTextDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ResourceListOfCategoryTextDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ResourceListOfCategoryTextDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns all cnrs that are known in PSL
   * @metadata (optional) metadata
   * @return OK
   */
  getCnrsUsingGET(
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfCnrDto>> {
    let url_ = this.baseUrl + '/cnrs?';
    if (metadata !== undefined)
      url_ += 'metadata=' + encodeURIComponent('' + metadata) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetCnrsUsingGET(_response)
        );
      });
  }

  protected processGetCnrsUsingGET(
    response: Response
  ): Promise<SwaggerResponse<ResourceListOfCnrDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ResourceListOfCnrDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ResourceListOfCnrDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns the basic market cnr
   * @return OK
   */
  getBasicMarketCnrUsingGET(): Promise<SwaggerResponse<CnrDto>> {
    let url_ = this.baseUrl + '/cnrs/basicMarket';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetBasicMarketCnrUsingGET(_response)
        );
      });
  }

  protected processGetBasicMarketCnrUsingGET(
    response: Response
  ): Promise<SwaggerResponse<CnrDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <CnrDto>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CnrDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * converts plain text into HTML formatted text
   * @textToConvert textToConvert
   * @return OK
   */
  convertToHTMLUsingPOST(
    textToConvert: string
  ): Promise<SwaggerResponse<string>> {
    let url_ = this.baseUrl + '/convertHTML';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(textToConvert);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processConvertToHTMLUsingPOST(_response)
        );
      });
  }

  protected processConvertToHTMLUsingPOST(
    response: Response
  ): Promise<SwaggerResponse<string>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <string>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<string>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * error
   * @return OK
   */
  errorUsingGET(): Promise<SwaggerResponse<{ [key: string]: any }>> {
    let url_ = this.baseUrl + '/error';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processErrorUsingGET(_response)
        );
      });
  }

  protected processErrorUsingGET(
    response: Response
  ): Promise<SwaggerResponse<{ [key: string]: any }>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <{ [key: string]: any }>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<{ [key: string]: any }>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * error
   * @return OK
   */
  errorUsingHEAD(): Promise<SwaggerResponse<{ [key: string]: any }>> {
    let url_ = this.baseUrl + '/error';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'HEAD',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processErrorUsingHEAD(_response)
        );
      });
  }

  protected processErrorUsingHEAD(
    response: Response
  ): Promise<SwaggerResponse<{ [key: string]: any }>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <{ [key: string]: any }>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<{ [key: string]: any }>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * error
   * @return OK
   */
  errorUsingPOST(): Promise<SwaggerResponse<{ [key: string]: any }>> {
    let url_ = this.baseUrl + '/error';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processErrorUsingPOST(_response)
        );
      });
  }

  protected processErrorUsingPOST(
    response: Response
  ): Promise<SwaggerResponse<{ [key: string]: any }>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <{ [key: string]: any }>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<{ [key: string]: any }>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * error
   * @return OK
   */
  errorUsingPUT(): Promise<SwaggerResponse<{ [key: string]: any }>> {
    let url_ = this.baseUrl + '/error';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processErrorUsingPUT(_response)
        );
      });
  }

  protected processErrorUsingPUT(
    response: Response
  ): Promise<SwaggerResponse<{ [key: string]: any }>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <{ [key: string]: any }>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<{ [key: string]: any }>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * error
   * @return OK
   */
  errorUsingDELETE(): Promise<SwaggerResponse<{ [key: string]: any }>> {
    let url_ = this.baseUrl + '/error';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processErrorUsingDELETE(_response)
        );
      });
  }

  protected processErrorUsingDELETE(
    response: Response
  ): Promise<SwaggerResponse<{ [key: string]: any }>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <{ [key: string]: any }>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<{ [key: string]: any }>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * error
   * @return OK
   */
  errorUsingOPTIONS(): Promise<SwaggerResponse<{ [key: string]: any }>> {
    let url_ = this.baseUrl + '/error';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'OPTIONS',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processErrorUsingOPTIONS(_response)
        );
      });
  }

  protected processErrorUsingOPTIONS(
    response: Response
  ): Promise<SwaggerResponse<{ [key: string]: any }>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <{ [key: string]: any }>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<{ [key: string]: any }>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * error
   * @return OK
   */
  errorUsingPATCH(): Promise<SwaggerResponse<{ [key: string]: any }>> {
    let url_ = this.baseUrl + '/error';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processErrorUsingPATCH(_response)
        );
      });
  }

  protected processErrorUsingPATCH(
    response: Response
  ): Promise<SwaggerResponse<{ [key: string]: any }>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <{ [key: string]: any }>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<{ [key: string]: any }>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * logging frontend error
   * @error error
   * @return OK
   */
  logErrorUsingPOST(error: FrontendError): Promise<SwaggerResponse<string>> {
    let url_ = this.baseUrl + '/error_reporting';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(error);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processLogErrorUsingPOST(_response)
        );
      });
  }

  protected processLogErrorUsingPOST(
    response: Response
  ): Promise<SwaggerResponse<string>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <string>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<string>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * exports options based on filters
   * @optionFilterDto optionFilterDto
   * @return OK
   */
  exportOptionsUsingPOST(
    optionFilterDto: OptionFilterDto
  ): Promise<SwaggerResponse<ExcelExportResponseDto>> {
    let url_ = this.baseUrl + '/excelexport/options';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(optionFilterDto);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processExportOptionsUsingPOST(_response)
        );
      });
  }

  protected processExportOptionsUsingPOST(
    response: Response
  ): Promise<SwaggerResponse<ExcelExportResponseDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ExcelExportResponseDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ExcelExportResponseDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * exports options to an excel file
   * @excelPropsDto excelPropsDto
   * @return OK
   */
  exportOptionsV2UsingPOST(
    excelPropsDto: ExcelPropsDto
  ): Promise<SwaggerResponse<ExcelExportResponseDto>> {
    let url_ = this.baseUrl + '/excelexport/options/v2';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(excelPropsDto);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processExportOptionsV2UsingPOST(_response)
        );
      });
  }

  protected processExportOptionsV2UsingPOST(
    response: Response
  ): Promise<SwaggerResponse<ExcelExportResponseDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ExcelExportResponseDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ExcelExportResponseDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * downloads excel file(identified by name) from the server
   * @fileName fileName
   * @return OK
   */
  downloadExcelV2UsingGET(
    fileName: string
  ): Promise<SwaggerResponse<ExcelDownloadResponseDto>> {
    let url_ = this.baseUrl + '/excelexport/options/v2/{fileName}';
    if (fileName === undefined || fileName === null)
      throw new Error("The parameter 'fileName' must be defined.");
    url_ = url_.replace('{fileName}', encodeURIComponent('' + fileName));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processDownloadExcelV2UsingGET(_response)
        );
      });
  }

  protected processDownloadExcelV2UsingGET(
    response: Response
  ): Promise<SwaggerResponse<ExcelDownloadResponseDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ExcelDownloadResponseDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ExcelDownloadResponseDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * downloads excel file, given by name, from the server
   * @fileName fileName
   * @return OK
   */
  downloadExcelUsingGET(
    fileName: string
  ): Promise<SwaggerResponse<ExcelDownloadResponseDto>> {
    let url_ = this.baseUrl + '/excelexport/options/{fileName}';
    if (fileName === undefined || fileName === null)
      throw new Error("The parameter 'fileName' must be defined.");
    url_ = url_.replace('{fileName}', encodeURIComponent('' + fileName));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processDownloadExcelUsingGET(_response)
        );
      });
  }

  protected processDownloadExcelUsingGET(
    response: Response
  ): Promise<SwaggerResponse<ExcelDownloadResponseDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ExcelDownloadResponseDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ExcelDownloadResponseDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * triggers the options texts export process from ProMT to PSL- only for tests!
   * @return OK
   */
  triggerOptionsTextsExportUsingGET(): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/exportOptionsTexts';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processTriggerOptionsTextsExportUsingGET(_response)
        );
      });
  }

  protected processTriggerOptionsTextsExportUsingGET(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns all groups that are known in PSL
   * @metadata (optional) metadata
   * @return OK
   */
  getGroupsUsingGET(
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfGroupDto>> {
    let url_ = this.baseUrl + '/groups?';
    if (metadata !== undefined)
      url_ += 'metadata=' + encodeURIComponent('' + metadata) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetGroupsUsingGET(_response)
        );
      });
  }

  protected processGetGroupsUsingGET(
    response: Response
  ): Promise<SwaggerResponse<ResourceListOfGroupDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ResourceListOfGroupDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ResourceListOfGroupDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * creates a new group in PSL
   * @group group
   * @return OK
   */
  addGroupUsingPOST(group: GroupDto): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/groups';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(group);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processAddGroupUsingPOST(_response)
        );
      });
  }

  protected processAddGroupUsingPOST(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result201);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * delete an existing group in PSL
   * @group group
   * @return group was deleted succesfully
   */
  deleteGroupUsingDELETE(group: GroupDto): Promise<SwaggerResponse<any>> {
    let url_ = this.baseUrl + '/groups';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(group);

    let options_ = <RequestInit>{
      body: content_,
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processDeleteGroupUsingDELETE(_response)
        );
      });
  }

  protected processDeleteGroupUsingDELETE(
    response: Response
  ): Promise<SwaggerResponse<any>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        let result204: any = null;
        result204 =
          _responseText === ''
            ? null
            : <any>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result204);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<any>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * updates an existing group in PSL
   * @group group
   * @return group was updated succesfully
   */
  updateGroupUsingPATCH(group: GroupDto): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/groups';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(group);

    let options_ = <RequestInit>{
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processUpdateGroupUsingPATCH(_response)
        );
      });
  }

  protected processUpdateGroupUsingPATCH(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * Gets all direct parent groups for a user.
   * @userCn userCn
   * @return groups were found succesfully
   */
  getDirectParentGroupsUsingGET(
    userCn: string
  ): Promise<SwaggerResponse<ResourceListOfGroupDto>> {
    let url_ = this.baseUrl + '/groups/direct?';
    if (userCn === undefined || userCn === null)
      throw new Error(
        "The parameter 'userCn' must be defined and cannot be null."
      );
    else url_ += 'userCn=' + encodeURIComponent('' + userCn) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetDirectParentGroupsUsingGET(_response)
        );
      });
  }

  protected processGetDirectParentGroupsUsingGET(
    response: Response
  ): Promise<SwaggerResponse<ResourceListOfGroupDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ResourceListOfGroupDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ResourceListOfGroupDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * Gets all indirect parent groups for a user.
   * @userCn userCn
   * @return groups were found succesfully
   */
  getIndirectParentGroupsUsingGET(
    userCn: string
  ): Promise<SwaggerResponse<ResourceListOfGroupDto>> {
    let url_ = this.baseUrl + '/groups/indirect?';
    if (userCn === undefined || userCn === null)
      throw new Error(
        "The parameter 'userCn' must be defined and cannot be null."
      );
    else url_ += 'userCn=' + encodeURIComponent('' + userCn) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetIndirectParentGroupsUsingGET(_response)
        );
      });
  }

  protected processGetIndirectParentGroupsUsingGET(
    response: Response
  ): Promise<SwaggerResponse<ResourceListOfGroupDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ResourceListOfGroupDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ResourceListOfGroupDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * get group details from LDAP
   * @groupName groupName
   * @return returns the detailed group-info from LDAP
   */
  getGroupLdapDetailsUsingGET(
    groupName: string
  ): Promise<SwaggerResponse<GroupDetailsDto>> {
    let url_ = this.baseUrl + '/groups/{groupName}/details';
    if (groupName === undefined || groupName === null)
      throw new Error("The parameter 'groupName' must be defined.");
    url_ = url_.replace('{groupName}', encodeURIComponent('' + groupName));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetGroupLdapDetailsUsingGET(_response)
        );
      });
  }

  protected processGetGroupLdapDetailsUsingGET(
    response: Response
  ): Promise<SwaggerResponse<GroupDetailsDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <GroupDetailsDto>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<GroupDetailsDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * get a single group by given id
   * @id id
   * @metadata (optional) metadata
   * @return returns a group identified by given id
   */
  findGroupByIdUsingGET(
    id: number,
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<GroupDto>> {
    let url_ = this.baseUrl + '/groups/{id}?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    if (metadata !== undefined)
      url_ += 'metadata=' + encodeURIComponent('' + metadata) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processFindGroupByIdUsingGET(_response)
        );
      });
  }

  protected processFindGroupByIdUsingGET(
    response: Response
  ): Promise<SwaggerResponse<GroupDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <GroupDto>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<GroupDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * triggers the category import process - only for tests!
   * @return OK
   */
  triggerCategoryImportUsingGET(): Promise<SwaggerResponse<void>> {
    let url_ = this.baseUrl + '/importCategory';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processTriggerCategoryImportUsingGET(_response)
        );
      });
  }

  protected processTriggerCategoryImportUsingGET(
    response: Response
  ): Promise<SwaggerResponse<void>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        return new SwaggerResponse(status, _headers, <any>null);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<void>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns all importers that are known in PSL
   * @metadata (optional) metadata
   * @return OK
   */
  getImportersUsingGET(
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfImporterDto>> {
    let url_ = this.baseUrl + '/importers?';
    if (metadata !== undefined)
      url_ += 'metadata=' + encodeURIComponent('' + metadata) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetImportersUsingGET(_response)
        );
      });
  }

  protected processGetImportersUsingGET(
    response: Response
  ): Promise<SwaggerResponse<ResourceListOfImporterDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ResourceListOfImporterDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ResourceListOfImporterDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns the init-data for the UI for a given user
   * @cn cn
   * @return OK
   */
  getInitDataUsingGET(cn: string): Promise<SwaggerResponse<InitDto>> {
    let url_ = this.baseUrl + '/initdata/{cn}';
    if (cn === undefined || cn === null)
      throw new Error("The parameter 'cn' must be defined.");
    url_ = url_.replace('{cn}', encodeURIComponent('' + cn));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetInitDataUsingGET(_response)
        );
      });
  }

  protected processGetInitDataUsingGET(
    response: Response
  ): Promise<SwaggerResponse<InitDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <InitDto>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<InitDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns all labels for a specific language code and namespace
   * @languageCode languageCode
   * @namespace namespace
   * @return returns all labels for a specific language code
   */
  findAllByLanguageCodeUsingGET(
    languageCode: string,
    namespace: string
  ): Promise<SwaggerResponse<string>> {
    let url_ = this.baseUrl + '/labels?';
    if (languageCode === undefined || languageCode === null)
      throw new Error(
        "The parameter 'languageCode' must be defined and cannot be null."
      );
    else url_ += 'languageCode=' + encodeURIComponent('' + languageCode) + '&';
    if (namespace === undefined || namespace === null)
      throw new Error(
        "The parameter 'namespace' must be defined and cannot be null."
      );
    else url_ += 'namespace=' + encodeURIComponent('' + namespace) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processFindAllByLanguageCodeUsingGET(_response)
        );
      });
  }

  protected processFindAllByLanguageCodeUsingGET(
    response: Response
  ): Promise<SwaggerResponse<string>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <string>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        let result204: any = null;
        result204 =
          _responseText === ''
            ? null
            : <string>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result204);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<string>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns all languages that are known in PSL
   * @metadata (optional) metadata
   * @return OK
   */
  getLanguagesUsingGET(
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfLanguageDto>> {
    let url_ = this.baseUrl + '/languages?';
    if (metadata !== undefined)
      url_ += 'metadata=' + encodeURIComponent('' + metadata) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetLanguagesUsingGET(_response)
        );
      });
  }

  protected processGetLanguagesUsingGET(
    response: Response
  ): Promise<SwaggerResponse<ResourceListOfLanguageDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ResourceListOfLanguageDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ResourceListOfLanguageDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * creates a new modeltype basic in PSL
   * @modeltypeBasic modeltypeBasic
   * @return OK
   */
  saveModeltypeBasicUsingPOST(
    modeltypeBasic: ModeltypeBasicDto
  ): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/modeltypeBasics';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(modeltypeBasic);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processSaveModeltypeBasicUsingPOST(_response)
        );
      });
  }

  protected processSaveModeltypeBasicUsingPOST(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result201);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * delete an existing modeltypebasic in PSL
   * @modeltypeBasic modeltypeBasic
   * @return OK
   */
  deleteModeltypeBasicUsingDELETE(
    modeltypeBasic: ModeltypeBasicDto
  ): Promise<SwaggerResponse<any>> {
    let url_ = this.baseUrl + '/modeltypeBasics';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(modeltypeBasic);

    let options_ = <RequestInit>{
      body: content_,
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processDeleteModeltypeBasicUsingDELETE(_response)
        );
      });
  }

  protected processDeleteModeltypeBasicUsingDELETE(
    response: Response
  ): Promise<SwaggerResponse<any>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <any>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        let result204: any = null;
        result204 =
          _responseText === ''
            ? null
            : <any>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result204);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 406) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<any>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * updates an existing modeltype basic in PSL
   * @modeltypeBasic modeltypeBasic
   * @return modeltype basic was updated succesfully
   */
  updateModeltypeBasicUsingPATCH(
    modeltypeBasic: ModeltypeBasicDto
  ): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/modeltypeBasics';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(modeltypeBasic);

    let options_ = <RequestInit>{
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processUpdateModeltypeBasicUsingPATCH(_response)
        );
      });
  }

  protected processUpdateModeltypeBasicUsingPATCH(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns the list of colors for modeltypes
   * @return returns the list of colors for modeltypes
   */
  getModeltypeBasicColorsUsingGET(): Promise<SwaggerResponse<string[]>> {
    let url_ = this.baseUrl + '/modeltypeBasics/colors';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetModeltypeBasicColorsUsingGET(_response)
        );
      });
  }

  protected processGetModeltypeBasicColorsUsingGET(
    response: Response
  ): Promise<SwaggerResponse<string[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<string[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * copies modeltype basics of the same typefamily from one modelyear to another
   * @modeltypeBasicCopyDto modeltypeBasicCopyDto
   * @return OK
   */
  copyModeltypeBasicsUsingPOST(
    modeltypeBasicCopyDto: ModeltypeBasicCopyDto
  ): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/modeltypeBasics/copy';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(modeltypeBasicCopyDto);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processCopyModeltypeBasicsUsingPOST(_response)
        );
      });
  }

  protected processCopyModeltypeBasicsUsingPOST(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result201);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 412) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * get PDiP modeltype basic data based on model year
   * @mj4 mj4
   * @return OK
   */
  getPDiPMTBsByModelyearUsingGET(
    mj4: number
  ): Promise<SwaggerResponse<PDiPModeltypebasicDto[]>> {
    let url_ = this.baseUrl + '/modeltypeBasics/pdip?';
    if (mj4 === undefined || mj4 === null)
      throw new Error(
        "The parameter 'mj4' must be defined and cannot be null."
      );
    else url_ += 'mj4=' + encodeURIComponent('' + mj4) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetPDiPMTBsByModelyearUsingGET(_response)
        );
      });
  }

  protected processGetPDiPMTBsByModelyearUsingGET(
    response: Response
  ): Promise<SwaggerResponse<PDiPModeltypebasicDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <PDiPModeltypebasicDto[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PDiPModeltypebasicDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns a single modeltype basic by given id
   * @id id
   * @metadata (optional) metadata
   * @return returns a option basic identified by given id
   */
  getModeltypeBasicUsingGET(
    id: number,
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ModeltypeBasicDto>> {
    let url_ = this.baseUrl + '/modeltypeBasics/{id}?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    if (metadata !== undefined)
      url_ += 'metadata=' + encodeURIComponent('' + metadata) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetModeltypeBasicUsingGET(_response)
        );
      });
  }

  protected processGetModeltypeBasicUsingGET(
    response: Response
  ): Promise<SwaggerResponse<ModeltypeBasicDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ModeltypeBasicDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ModeltypeBasicDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * get the derivate psl connections
   * @id id
   * @return OK
   */
  getModeltypeBasicPslConnectionsUsingGET(
    id: number
  ): Promise<SwaggerResponse<{ [key: string]: number }>> {
    let url_ = this.baseUrl + '/modeltypeBasics/{id}/connections';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetModeltypeBasicPslConnectionsUsingGET(_response)
        );
      });
  }

  protected processGetModeltypeBasicPslConnectionsUsingGET(
    response: Response
  ): Promise<SwaggerResponse<{ [key: string]: number }>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <{ [key: string]: number }>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<{ [key: string]: number }>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns all modelyears that are known in PSL
   * @metadata (optional) metadata
   * @return OK
   */
  getModelyearsUsingGET(
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfModelyearDto>> {
    let url_ = this.baseUrl + '/modelyears?';
    if (metadata !== undefined)
      url_ += 'metadata=' + encodeURIComponent('' + metadata) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetModelyearsUsingGET(_response)
        );
      });
  }

  protected processGetModelyearsUsingGET(
    response: Response
  ): Promise<SwaggerResponse<ResourceListOfModelyearDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ResourceListOfModelyearDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ResourceListOfModelyearDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns a single modelyear
   * @id id
   * @metadata (optional) metadata
   * @return OK
   */
  getModelyearByIdUsingGET(
    id: number,
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ModelyearDto>> {
    let url_ = this.baseUrl + '/modelyears/{id}?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    if (metadata !== undefined)
      url_ += 'metadata=' + encodeURIComponent('' + metadata) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetModelyearByIdUsingGET(_response)
        );
      });
  }

  protected processGetModelyearByIdUsingGET(
    response: Response
  ): Promise<SwaggerResponse<ModelyearDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ModelyearDto>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ModelyearDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * get PDiP option basic data based on model year
   * @mj4 mj4
   * @return OK
   */
  getPDiPOBsByModelyearUsingGET(
    mj4: number
  ): Promise<SwaggerResponse<PDiPOptionBasicDto[]>> {
    let url_ = this.baseUrl + '/optionBasic/pdip?';
    if (mj4 === undefined || mj4 === null)
      throw new Error(
        "The parameter 'mj4' must be defined and cannot be null."
      );
    else url_ += 'mj4=' + encodeURIComponent('' + mj4) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetPDiPOBsByModelyearUsingGET(_response)
        );
      });
  }

  protected processGetPDiPOBsByModelyearUsingGET(
    response: Response
  ): Promise<SwaggerResponse<PDiPOptionBasicDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <PDiPOptionBasicDto[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PDiPOptionBasicDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * creates a new option basic in PSL
   * @optionBasic optionBasic
   * @return OK
   */
  addOptionBasicUsingPOST(
    optionBasic: OptionBasicDto
  ): Promise<SwaggerResponse<OptionBasicDto>> {
    let url_ = this.baseUrl + '/optionBasics';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(optionBasic);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processAddOptionBasicUsingPOST(_response)
        );
      });
  }

  protected processAddOptionBasicUsingPOST(
    response: Response
  ): Promise<SwaggerResponse<OptionBasicDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <OptionBasicDto>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === ''
            ? null
            : <OptionBasicDto>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result201);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<OptionBasicDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * deletes an existing option basic in PSL
   * @optionBasic optionBasic
   * @return OK
   */
  deleteOptionBasicUsingDELETE(
    optionBasic: OptionBasicDto
  ): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/optionBasics';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(optionBasic);

    let options_ = <RequestInit>{
      body: content_,
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processDeleteOptionBasicUsingDELETE(_response)
        );
      });
  }

  protected processDeleteOptionBasicUsingDELETE(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        let result204: any = null;
        result204 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result204);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * updates an existing option basic in PSL
   * @optionBasic optionBasic
   * @return option basic was updated succesfully
   */
  updateOptionBasicUsingPATCH(
    optionBasic: OptionBasicDto
  ): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/optionBasics';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(optionBasic);

    let options_ = <RequestInit>{
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processUpdateOptionBasicUsingPATCH(_response)
        );
      });
  }

  protected processUpdateOptionBasicUsingPATCH(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * copies existing option basics of one modelyear to another
   * @copyDto copyDto
   * @return OK
   */
  copyModelYearOptionBasicsUsingPOST(
    copyDto: OptionBasicMYCopyDto
  ): Promise<SwaggerResponse<OptionBasicMYCopySummaryDto>> {
    let url_ = this.baseUrl + '/optionBasics/copy/';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(copyDto);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processCopyModelYearOptionBasicsUsingPOST(_response)
        );
      });
  }

  protected processCopyModelYearOptionBasicsUsingPOST(
    response: Response
  ): Promise<SwaggerResponse<OptionBasicMYCopySummaryDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <OptionBasicMYCopySummaryDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<OptionBasicMYCopySummaryDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns the copy conflict status for the source context data
   * @sourceModelyearId sourceModelyearId
   * @targetModelyearId targetModelyearId
   * @return Option basic modelyear copy conflict status returned.
   */
  getOptionBasicMYCopyConflictStatusUsingGET(
    sourceModelyearId: number,
    targetModelyearId: number
  ): Promise<SwaggerResponse<OptionBasicMYCopyConflictDto[]>> {
    let url_ = this.baseUrl + '/optionBasics/copyConflictStatus/?';
    if (sourceModelyearId === undefined || sourceModelyearId === null)
      throw new Error(
        "The parameter 'sourceModelyearId' must be defined and cannot be null."
      );
    else
      url_ +=
        'sourceModelyearId=' + encodeURIComponent('' + sourceModelyearId) + '&';
    if (targetModelyearId === undefined || targetModelyearId === null)
      throw new Error(
        "The parameter 'targetModelyearId' must be defined and cannot be null."
      );
    else
      url_ +=
        'targetModelyearId=' + encodeURIComponent('' + targetModelyearId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetOptionBasicMYCopyConflictStatusUsingGET(_response)
        );
      });
  }

  protected processGetOptionBasicMYCopyConflictStatusUsingGET(
    response: Response
  ): Promise<SwaggerResponse<OptionBasicMYCopyConflictDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <OptionBasicMYCopyConflictDto[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<OptionBasicMYCopyConflictDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * gets PSL contexts dependencies for option basics
   * @optionBasicIds optionBasicIds
   * @return OK
   */
  getOptionBasicDeleteDependenciesUsingGET(
    optionBasicIds: number[]
  ): Promise<SwaggerResponse<{ [key: string]: OptionBasicPSLDependencyDto }>> {
    let url_ = this.baseUrl + '/optionBasics/deleteDependencies?';
    if (optionBasicIds === undefined || optionBasicIds === null)
      throw new Error(
        "The parameter 'optionBasicIds' must be defined and cannot be null."
      );
    else
      optionBasicIds &&
        optionBasicIds.forEach((item) => {
          url_ += 'optionBasicIds=' + encodeURIComponent('' + item) + '&';
        });
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetOptionBasicDeleteDependenciesUsingGET(_response)
        );
      });
  }

  protected processGetOptionBasicDeleteDependenciesUsingGET(
    response: Response
  ): Promise<SwaggerResponse<{ [key: string]: OptionBasicPSLDependencyDto }>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <{ [key: string]: OptionBasicPSLDependencyDto }>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<
      SwaggerResponse<{ [key: string]: OptionBasicPSLDependencyDto }>
    >(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * returns extra endpoints for the base options page
   * @return OK
   */
  getOptionBasicAreaExtraLinksUsingGET(): Promise<SwaggerResponse<MenuDto>> {
    let url_ = this.baseUrl + '/optionBasics/extraLinks';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetOptionBasicAreaExtraLinksUsingGET(_response)
        );
      });
  }

  protected processGetOptionBasicAreaExtraLinksUsingGET(
    response: Response
  ): Promise<SwaggerResponse<MenuDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <MenuDto>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<MenuDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns a map with the base option id as key and as value a status, whether the OB can be initialized or not( based on OB, C number and type family
   * @typeFamily typeFamily
   * @optionBasicDtoIds optionBasicDtoIds
   * @return OK
   */
  getOptionBasicInitStatusUsingGET(
    typeFamily: number,
    optionBasicDtoIds: number[]
  ): Promise<SwaggerResponse<{ [key: string]: boolean }>> {
    let url_ = this.baseUrl + '/optionBasics/initStatus?';
    if (typeFamily === undefined || typeFamily === null)
      throw new Error(
        "The parameter 'typeFamily' must be defined and cannot be null."
      );
    else url_ += 'typeFamily=' + encodeURIComponent('' + typeFamily) + '&';
    if (optionBasicDtoIds === undefined || optionBasicDtoIds === null)
      throw new Error(
        "The parameter 'optionBasicDtoIds' must be defined and cannot be null."
      );
    else
      optionBasicDtoIds &&
        optionBasicDtoIds.forEach((item) => {
          url_ += 'optionBasicDtoIds=' + encodeURIComponent('' + item) + '&';
        });
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetOptionBasicInitStatusUsingGET(_response)
        );
      });
  }

  protected processGetOptionBasicInitStatusUsingGET(
    response: Response
  ): Promise<SwaggerResponse<{ [key: string]: boolean }>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <{ [key: string]: boolean }>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<{ [key: string]: boolean }>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns a single option basic by given id
   * @id id
   * @metadata (optional) metadata
   * @return returns a option basic identified by given id
   */
  getOptionBasicUsingGET(
    id: number,
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<OptionBasicDto>> {
    let url_ = this.baseUrl + '/optionBasics/{id}?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    if (metadata !== undefined)
      url_ += 'metadata=' + encodeURIComponent('' + metadata) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetOptionBasicUsingGET(_response)
        );
      });
  }

  protected processGetOptionBasicUsingGET(
    response: Response
  ): Promise<SwaggerResponse<OptionBasicDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <OptionBasicDto>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<OptionBasicDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * creates a new BM option or a specific option of type EOptionSpecificType.COPY based on a template option
   * @simpleOptionCopyDto simpleOptionCopyDto
   * @return OK
   */
  copyOptionUsingPOST(
    simpleOptionCopyDto: SimpleOptionCopyDto
  ): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/options';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(simpleOptionCopyDto);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processCopyOptionUsingPOST(_response)
        );
      });
  }

  protected processCopyOptionUsingPOST(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * deletes an existing option
   * @dto dto
   * @return OK
   */
  deleteOptionUsingDELETE(dto: OptionDto): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/options';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(dto);

    let options_ = <RequestInit>{
      body: content_,
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processDeleteOptionUsingDELETE(_response)
        );
      });
  }

  protected processDeleteOptionUsingDELETE(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        let result204: any = null;
        result204 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result204);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * updates an existing option
   * @dto dto
   * @return Option was updated succesfully
   */
  updateOptionUsingPATCH(dto: OptionUpdateDto): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/options';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(dto);

    let options_ = <RequestInit>{
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processUpdateOptionUsingPATCH(_response)
        );
      });
  }

  protected processUpdateOptionUsingPATCH(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns an option for the given parent id
   * @parentId parentId
   * @return OK
   */
  getOptionByParentIdUsingGET(
    parentId: number
  ): Promise<SwaggerResponse<OptionDto[]>> {
    let url_ = this.baseUrl + '/options/child/{parentId}';
    if (parentId === undefined || parentId === null)
      throw new Error("The parameter 'parentId' must be defined.");
    url_ = url_.replace('{parentId}', encodeURIComponent('' + parentId));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetOptionByParentIdUsingGET(_response)
        );
      });
  }

  protected processGetOptionByParentIdUsingGET(
    response: Response
  ): Promise<SwaggerResponse<OptionDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <OptionDto[]>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<OptionDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns the differences between a given specific market option and its parent basic market option
   * @childId childId
   * @return OK
   */
  getDifferencesUsingGET(
    childId: number
  ): Promise<SwaggerResponse<OptionDifferenceDto>> {
    let url_ = this.baseUrl + '/options/compare/{childId}';
    if (childId === undefined || childId === null)
      throw new Error("The parameter 'childId' must be defined.");
    url_ = url_.replace('{childId}', encodeURIComponent('' + childId));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetDifferencesUsingGET(_response)
        );
      });
  }

  protected processGetDifferencesUsingGET(
    response: Response
  ): Promise<SwaggerResponse<OptionDifferenceDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <OptionDifferenceDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<OptionDifferenceDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * updates the constraint values for an existing option
   * @dto dto
   * @return OK
   */
  updateOptionConstraintUsingPATCH(
    dto: OptionDto
  ): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/options/constraint';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(dto);

    let options_ = <RequestInit>{
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processUpdateOptionConstraintUsingPATCH(_response)
        );
      });
  }

  protected processUpdateOptionConstraintUsingPATCH(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * copies existing PSL contexts to target contexts
   * @sourceModelyearId sourceModelyearId
   * @sourceTypefamilyId sourceTypefamilyId
   * @targetModelyearId targetModelyearId
   * @targetTypefamilyId targetTypefamilyId
   * @return OK
   */
  copyPSLContextsUsingPOST(
    sourceModelyearId: number,
    sourceTypefamilyId: number,
    targetModelyearId: number,
    targetTypefamilyId: number
  ): Promise<SwaggerResponse<PSLCopyResultSummaryDto>> {
    let url_ = this.baseUrl + '/options/copy?';
    if (sourceModelyearId === undefined || sourceModelyearId === null)
      throw new Error(
        "The parameter 'sourceModelyearId' must be defined and cannot be null."
      );
    else
      url_ +=
        'sourceModelyearId=' + encodeURIComponent('' + sourceModelyearId) + '&';
    if (sourceTypefamilyId === undefined || sourceTypefamilyId === null)
      throw new Error(
        "The parameter 'sourceTypefamilyId' must be defined and cannot be null."
      );
    else
      url_ +=
        'sourceTypefamilyId=' +
        encodeURIComponent('' + sourceTypefamilyId) +
        '&';
    if (targetModelyearId === undefined || targetModelyearId === null)
      throw new Error(
        "The parameter 'targetModelyearId' must be defined and cannot be null."
      );
    else
      url_ +=
        'targetModelyearId=' + encodeURIComponent('' + targetModelyearId) + '&';
    if (targetTypefamilyId === undefined || targetTypefamilyId === null)
      throw new Error(
        "The parameter 'targetTypefamilyId' must be defined and cannot be null."
      );
    else
      url_ +=
        'targetTypefamilyId=' +
        encodeURIComponent('' + targetTypefamilyId) +
        '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processCopyPSLContextsUsingPOST(_response)
        );
      });
  }

  protected processCopyPSLContextsUsingPOST(
    response: Response
  ): Promise<SwaggerResponse<PSLCopyResultSummaryDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <PSLCopyResultSummaryDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PSLCopyResultSummaryDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * updates the exclusion for an existing option
   * @dto dto
   * @return OK
   */
  updateOptionExclusionUsingPATCH(
    dto: OptionDto
  ): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/options/exclusion';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(dto);

    let options_ = <RequestInit>{
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processUpdateOptionExclusionUsingPATCH(_response)
        );
      });
  }

  protected processUpdateOptionExclusionUsingPATCH(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns extra endpoints for the PSL page
   * @return OK
   */
  getPSLAreaExtraLinksUsingGET(): Promise<SwaggerResponse<MenuDto>> {
    let url_ = this.baseUrl + '/options/extraLinks';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetPSLAreaExtraLinksUsingGET(_response)
        );
      });
  }

  protected processGetPSLAreaExtraLinksUsingGET(
    response: Response
  ): Promise<SwaggerResponse<MenuDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <MenuDto>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<MenuDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * updates the modeltypeBasic assignments for an existing option
   * @optionDto optionDto
   * @return OK
   */
  updateOptionModeltypeBasicAssignmentsUsingPATCH(
    optionDto: OptionDto
  ): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/options/modeltypeBasicAssignments';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(optionDto);

    let options_ = <RequestInit>{
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processUpdateOptionModeltypeBasicAssignmentsUsingPATCH(_response)
        );
      });
  }

  protected processUpdateOptionModeltypeBasicAssignmentsUsingPATCH(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * update the workflow status of options based on an action type
   * @reqBody reqBody
   * @return OK
   */
  multiUpdateOptionsWorkflowStatusUsingPATCH(
    reqBody: OptionWorkflowStatusMultiUpdateParam
  ): Promise<SwaggerResponse<number>> {
    let url_ = this.baseUrl + '/options/multiUpdateOptionsWorkflowStatus';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(reqBody);

    let options_ = <RequestInit>{
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processMultiUpdateOptionsWorkflowStatusUsingPATCH(_response)
        );
      });
  }

  protected processMultiUpdateOptionsWorkflowStatusUsingPATCH(
    response: Response
  ): Promise<SwaggerResponse<number>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <number>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<number>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * deletes a list of options
   * @optionDtos optionDtos
   * @return OK
   */
  multiDeleteOptionsUsingPATCH(
    optionDtos: DtoListWithLinksOfOptionDto
  ): Promise<SwaggerResponse<number[]>> {
    let url_ = this.baseUrl + '/options/multipleOptionDeletion';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(optionDtos);

    let options_ = <RequestInit>{
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processMultiDeleteOptionsUsingPATCH(_response)
        );
      });
  }

  protected processMultiDeleteOptionsUsingPATCH(
    response: Response
  ): Promise<SwaggerResponse<number[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <number[]>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<number[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * updates the package content for an existing option
   * @dto dto
   * @return OK
   */
  updateOptionPackageContentUsingPATCH(
    dto: OptionDto
  ): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/options/packageContent';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(dto);

    let options_ = <RequestInit>{
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processUpdateOptionPackageContentUsingPATCH(_response)
        );
      });
  }

  protected processUpdateOptionPackageContentUsingPATCH(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * return the conflicts between two psl contexts
   * @sourceModelyearId sourceModelyearId
   * @sourceTypefamilyId sourceTypefamilyId
   * @targetModelyearId targetModelyearId
   * @targetTypefamilyId targetTypefamilyId
   * @return PSL context copy conflicts returned.
   */
  getPSLCopyConflictsUsingGET(
    sourceModelyearId: number,
    sourceTypefamilyId: number,
    targetModelyearId: number,
    targetTypefamilyId: number
  ): Promise<SwaggerResponse<PSLCopyConflictDto[]>> {
    let url_ = this.baseUrl + '/options/psl/copyConflicts?';
    if (sourceModelyearId === undefined || sourceModelyearId === null)
      throw new Error(
        "The parameter 'sourceModelyearId' must be defined and cannot be null."
      );
    else
      url_ +=
        'sourceModelyearId=' + encodeURIComponent('' + sourceModelyearId) + '&';
    if (sourceTypefamilyId === undefined || sourceTypefamilyId === null)
      throw new Error(
        "The parameter 'sourceTypefamilyId' must be defined and cannot be null."
      );
    else
      url_ +=
        'sourceTypefamilyId=' +
        encodeURIComponent('' + sourceTypefamilyId) +
        '&';
    if (targetModelyearId === undefined || targetModelyearId === null)
      throw new Error(
        "The parameter 'targetModelyearId' must be defined and cannot be null."
      );
    else
      url_ +=
        'targetModelyearId=' + encodeURIComponent('' + targetModelyearId) + '&';
    if (targetTypefamilyId === undefined || targetTypefamilyId === null)
      throw new Error(
        "The parameter 'targetTypefamilyId' must be defined and cannot be null."
      );
    else
      url_ +=
        'targetTypefamilyId=' +
        encodeURIComponent('' + targetTypefamilyId) +
        '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetPSLCopyConflictsUsingGET(_response)
        );
      });
  }

  protected processGetPSLCopyConflictsUsingGET(
    response: Response
  ): Promise<SwaggerResponse<PSLCopyConflictDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <PSLCopyConflictDto[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<PSLCopyConflictDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns data for cnrs that contain options for the search context and the count
   * @modelyearId modelyearId
   * @typefamilyId typefamilyId
   * @return OK
   */
  getPSLStatsUsingGET(
    modelyearId: number,
    typefamilyId: number
  ): Promise<SwaggerResponse<{ [key: string]: number }>> {
    let url_ = this.baseUrl + '/options/psl/stats?';
    if (modelyearId === undefined || modelyearId === null)
      throw new Error(
        "The parameter 'modelyearId' must be defined and cannot be null."
      );
    else url_ += 'modelyearId=' + encodeURIComponent('' + modelyearId) + '&';
    if (typefamilyId === undefined || typefamilyId === null)
      throw new Error(
        "The parameter 'typefamilyId' must be defined and cannot be null."
      );
    else url_ += 'typefamilyId=' + encodeURIComponent('' + typefamilyId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetPSLStatsUsingGET(_response)
        );
      });
  }

  protected processGetPSLStatsUsingGET(
    response: Response
  ): Promise<SwaggerResponse<{ [key: string]: number }>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <{ [key: string]: number }>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<{ [key: string]: number }>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * resets the workflow for an existing option
   * @dto dto
   * @return Option workflow was reset successfuly!
   */
  resetOptionWorkflowUsingPATCH(
    dto: OptionDto
  ): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/options/reset';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(dto);

    let options_ = <RequestInit>{
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processResetOptionWorkflowUsingPATCH(_response)
        );
      });
  }

  protected processResetOptionWorkflowUsingPATCH(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * Creates specific option / options from a list of specific market options
   * @initSpecificOptionDto initSpecificOptionDto
   * @return OK
   */
  initSpecificMarketOptionsUsingPOST(
    initSpecificOptionDto: SpecificOptionInitDto
  ): Promise<SwaggerResponse<ResourceListOfOptionDto>> {
    let url_ = this.baseUrl + '/options/specific';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(initSpecificOptionDto);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processInitSpecificMarketOptionsUsingPOST(_response)
        );
      });
  }

  protected processInitSpecificMarketOptionsUsingPOST(
    response: Response
  ): Promise<SwaggerResponse<ResourceListOfOptionDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ResourceListOfOptionDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ResourceListOfOptionDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * updates a specific option of type DEPENDENT_OVERWRITE to INDEPENDENT_OVERWRITE
   * @optionId optionId
   * @return OK
   */
  createIndependentOverwriteSpecificOptionUsingPATCH(
    optionId: number
  ): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/options/specificIndependent/{optionId}';
    if (optionId === undefined || optionId === null)
      throw new Error("The parameter 'optionId' must be defined.");
    url_ = url_.replace('{optionId}', encodeURIComponent('' + optionId));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processCreateIndependentOverwriteSpecificOptionUsingPATCH(
            _response
          )
        );
      });
  }

  protected processCreateIndependentOverwriteSpecificOptionUsingPATCH(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * updates the texts assignments for an existing option
   * @optionDto optionDto
   * @return OK
   */
  updateOptionTextsUsingPATCH(
    optionDto: OptionDto
  ): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/options/texts';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(optionDto);

    let options_ = <RequestInit>{
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processUpdateOptionTextsUsingPATCH(_response)
        );
      });
  }

  protected processUpdateOptionTextsUsingPATCH(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * transfer/update of derivate assignments for options
   * @dto dto
   * @return OK
   */
  transferOptionAssignmentsUsingPATCH(
    dto: AssignmentTransferDto
  ): Promise<SwaggerResponse<{ [key: string]: string }>> {
    let url_ = this.baseUrl + '/options/transferAssignments';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(dto);

    let options_ = <RequestInit>{
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processTransferOptionAssignmentsUsingPATCH(_response)
        );
      });
  }

  protected processTransferOptionAssignmentsUsingPATCH(
    response: Response
  ): Promise<SwaggerResponse<{ [key: string]: string }>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <{ [key: string]: string }>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<{ [key: string]: string }>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns an option for the given id
   * @optionId optionId
   * @metadata (optional) metadata
   * @return OK
   */
  getOptionByIdUsingGET(
    optionId: number,
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<OptionDto>> {
    let url_ = this.baseUrl + '/options/{optionId}?';
    if (optionId === undefined || optionId === null)
      throw new Error("The parameter 'optionId' must be defined.");
    url_ = url_.replace('{optionId}', encodeURIComponent('' + optionId));
    if (metadata !== undefined)
      url_ += 'metadata=' + encodeURIComponent('' + metadata) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetOptionByIdUsingGET(_response)
        );
      });
  }

  protected processGetOptionByIdUsingGET(
    response: Response
  ): Promise<SwaggerResponse<OptionDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <OptionDto>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<OptionDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * return the modeltypeBasics that are already assigned to an option's family
   * @optionId optionId
   * @cnrId cnrId
   * @return OK
   */
  getModeltypeBasicAssignmentsConflictsForCopyUsingGET(
    optionId: number,
    cnrId: number
  ): Promise<SwaggerResponse<{ [key: string]: string[] }>> {
    let url_ =
      this.baseUrl + '/options/{optionId}/modeltypeBasicConflict/copy?';
    if (optionId === undefined || optionId === null)
      throw new Error("The parameter 'optionId' must be defined.");
    url_ = url_.replace('{optionId}', encodeURIComponent('' + optionId));
    if (cnrId === undefined || cnrId === null)
      throw new Error(
        "The parameter 'cnrId' must be defined and cannot be null."
      );
    else url_ += 'cnrId=' + encodeURIComponent('' + cnrId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetModeltypeBasicAssignmentsConflictsForCopyUsingGET(
            _response
          )
        );
      });
  }

  protected processGetModeltypeBasicAssignmentsConflictsForCopyUsingGET(
    response: Response
  ): Promise<SwaggerResponse<{ [key: string]: string[] }>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <{ [key: string]: string[] }>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<{ [key: string]: string[] }>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * return the modeltypeBasics that cannot be used because they are already assigned to the option's family
   * @optionId optionId
   * @return OK
   */
  getModeltypeBasicAssignmentsConflictsForUpdateUsingGET(
    optionId: number
  ): Promise<SwaggerResponse<{ [key: string]: string[] }>> {
    let url_ =
      this.baseUrl + '/options/{optionId}/modeltypeBasicConflict/update';
    if (optionId === undefined || optionId === null)
      throw new Error("The parameter 'optionId' must be defined.");
    url_ = url_.replace('{optionId}', encodeURIComponent('' + optionId));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetModeltypeBasicAssignmentsConflictsForUpdateUsingGET(
            _response
          )
        );
      });
  }

  protected processGetModeltypeBasicAssignmentsConflictsForUpdateUsingGET(
    response: Response
  ): Promise<SwaggerResponse<{ [key: string]: string[] }>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <{ [key: string]: string[] }>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<{ [key: string]: string[] }>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * creates a new PSL
   * @optionInitDto optionInitDto
   * @return OK
   */
  createOptionWithContextUsingPOST(
    optionInitDto: OptionInitDto
  ): Promise<SwaggerResponse<{ [key: string]: string }>> {
    let url_ = this.baseUrl + '/options_with_context';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(optionInitDto);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processCreateOptionWithContextUsingPOST(_response)
        );
      });
  }

  protected processCreateOptionWithContextUsingPOST(
    response: Response
  ): Promise<SwaggerResponse<{ [key: string]: string }>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <{ [key: string]: string }>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<{ [key: string]: string }>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * Returns all cnrs available in ProMT
   * @return Request was processed succesfully, data is returned.
   */
  getAllCnrsUsingGET(): Promise<SwaggerResponse<CnrExtDto[]>> {
    let url_ = this.baseUrl + '/ospapi/v1/cnrs';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetAllCnrsUsingGET(_response)
        );
      });
  }

  protected processGetAllCnrsUsingGET(
    response: Response
  ): Promise<SwaggerResponse<CnrExtDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <CnrExtDto[]>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        let result204: any = null;
        result204 =
          _responseText === ''
            ? null
            : <CnrExtDto[]>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result204);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<CnrExtDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * Returns all active modeltypeBasic/derivates that are in PSL and have BTYP!=null.
   * @modelyear modelyear
   * @return Request was processed succesfully, data is returned.
   */
  getModeltypeBasicForUsingGET(
    modelyear: string
  ): Promise<SwaggerResponse<ModeltypeBasicExtDto[]>> {
    let url_ = this.baseUrl + '/ospapi/v1/derivates/{modelyear}';
    if (modelyear === undefined || modelyear === null)
      throw new Error("The parameter 'modelyear' must be defined.");
    url_ = url_.replace('{modelyear}', encodeURIComponent('' + modelyear));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetModeltypeBasicForUsingGET(_response)
        );
      });
  }

  protected processGetModeltypeBasicForUsingGET(
    response: Response
  ): Promise<SwaggerResponse<ModeltypeBasicExtDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ModeltypeBasicExtDto[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        let result204: any = null;
        result204 =
          _responseText === ''
            ? null
            : <ModeltypeBasicExtDto[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result204);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ModeltypeBasicExtDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * Returns all model years available in ProMT
   * @return Request was processed succesfully, data is returned.
   */
  getAllModelyearsUsingGET(): Promise<SwaggerResponse<ModelyearExtDto[]>> {
    let url_ = this.baseUrl + '/ospapi/v1/modelyears';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetAllModelyearsUsingGET(_response)
        );
      });
  }

  protected processGetAllModelyearsUsingGET(
    response: Response
  ): Promise<SwaggerResponse<ModelyearExtDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ModelyearExtDto[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        let result204: any = null;
        result204 =
          _responseText === ''
            ? null
            : <ModelyearExtDto[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result204);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ModelyearExtDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * Returns all approved basic options that are in ProMT and have option code not null.
   * @modelyear modelyear
   * @return Request was processed succesfully, data is returned.
   */
  getOptionBasicsForUsingGET(
    modelyear: string
  ): Promise<SwaggerResponse<OptionBasicExtDto[]>> {
    let url_ = this.baseUrl + '/ospapi/v1/optionBasic/{modelyear}';
    if (modelyear === undefined || modelyear === null)
      throw new Error("The parameter 'modelyear' must be defined.");
    url_ = url_.replace('{modelyear}', encodeURIComponent('' + modelyear));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetOptionBasicsForUsingGET(_response)
        );
      });
  }

  protected processGetOptionBasicsForUsingGET(
    response: Response
  ): Promise<SwaggerResponse<OptionBasicExtDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <OptionBasicExtDto[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        let result204: any = null;
        result204 =
          _responseText === ''
            ? null
            : <OptionBasicExtDto[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result204);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<OptionBasicExtDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * Returns all typefamilies available in ProMT
   * @return Request was processed succesfully, data is returned.
   */
  getAllTypefamiliesUsingGET(): Promise<SwaggerResponse<TypefamilyExtDto[]>> {
    let url_ = this.baseUrl + '/ospapi/v1/typefamilies';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetAllTypefamiliesUsingGET(_response)
        );
      });
  }

  protected processGetAllTypefamiliesUsingGET(
    response: Response
  ): Promise<SwaggerResponse<TypefamilyExtDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <TypefamilyExtDto[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        let result204: any = null;
        result204 =
          _responseText === ''
            ? null
            : <TypefamilyExtDto[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result204);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<TypefamilyExtDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns all importers that are mapped in PSL to the given context
   * @modelyear modelyear
   * @btyp btyp
   * @pCCD_TECH_ID PCCD_TECH_ID
   * @payload payload
   * @return OK
   */
  getImporterMappingForUsingPOST(
    modelyear: string,
    btyp: string,
    pCCD_TECH_ID: string,
    payload: ImporterExtDto[]
  ): Promise<SwaggerResponse<ImporterExtDto[]>> {
    let url_ =
      this.baseUrl + '/pccdapi/v1/importers/{modelyear}/{btyp}/{PCCD_TECH_ID}';
    if (modelyear === undefined || modelyear === null)
      throw new Error("The parameter 'modelyear' must be defined.");
    url_ = url_.replace('{modelyear}', encodeURIComponent('' + modelyear));
    if (btyp === undefined || btyp === null)
      throw new Error("The parameter 'btyp' must be defined.");
    url_ = url_.replace('{btyp}', encodeURIComponent('' + btyp));
    if (pCCD_TECH_ID === undefined || pCCD_TECH_ID === null)
      throw new Error("The parameter 'pCCD_TECH_ID' must be defined.");
    url_ = url_.replace(
      '{PCCD_TECH_ID}',
      encodeURIComponent('' + pCCD_TECH_ID)
    );
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(payload);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetImporterMappingForUsingPOST(_response)
        );
      });
  }

  protected processGetImporterMappingForUsingPOST(
    response: Response
  ): Promise<SwaggerResponse<ImporterExtDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ImporterExtDto[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ImporterExtDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns the current monitoring-path
   * @return OK
   */
  getMonitoringPathUsingGET(): Promise<SwaggerResponse<string>> {
    let url_ = this.baseUrl + '/performance';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetMonitoringPathUsingGET(_response)
        );
      });
  }

  protected processGetMonitoringPathUsingGET(
    response: Response
  ): Promise<SwaggerResponse<string>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <string>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<string>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * get priveleges
   * @metadata (optional) metadata
   * @return OK
   */
  getPrivelegesUsingGET(
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfPrivilegeDto>> {
    let url_ = this.baseUrl + '/privileges?';
    if (metadata !== undefined)
      url_ += 'metadata=' + encodeURIComponent('' + metadata) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetPrivelegesUsingGET(_response)
        );
      });
  }

  protected processGetPrivelegesUsingGET(
    response: Response
  ): Promise<SwaggerResponse<ResourceListOfPrivilegeDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ResourceListOfPrivilegeDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ResourceListOfPrivilegeDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * check if a PSL is complete based on PCCD data
   * @modelyearId modelyearId
   * @typefamilyId typefamilyId
   * @cnrId cnrId
   * @return OK
   */
  checkPSLandPCCDSynchronisationUsingGET(
    modelyearId: number,
    typefamilyId: number,
    cnrId: number
  ): Promise<SwaggerResponse<MissingAssignmentsAndDerivateDTO>> {
    let url_ =
      this.baseUrl +
      '/psl/{modelyearId}/{typefamilyId}/{cnrId}/pccdSyncronisation';
    if (modelyearId === undefined || modelyearId === null)
      throw new Error("The parameter 'modelyearId' must be defined.");
    url_ = url_.replace('{modelyearId}', encodeURIComponent('' + modelyearId));
    if (typefamilyId === undefined || typefamilyId === null)
      throw new Error("The parameter 'typefamilyId' must be defined.");
    url_ = url_.replace(
      '{typefamilyId}',
      encodeURIComponent('' + typefamilyId)
    );
    if (cnrId === undefined || cnrId === null)
      throw new Error("The parameter 'cnrId' must be defined.");
    url_ = url_.replace('{cnrId}', encodeURIComponent('' + cnrId));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processCheckPSLandPCCDSynchronisationUsingGET(_response)
        );
      });
  }

  protected processCheckPSLandPCCDSynchronisationUsingGET(
    response: Response
  ): Promise<SwaggerResponse<MissingAssignmentsAndDerivateDTO>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <MissingAssignmentsAndDerivateDTO>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<MissingAssignmentsAndDerivateDTO>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * get all roles
   * @metadata (optional) metadata
   * @return OK
   */
  findAllUsingGET(
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfRoleDto>> {
    let url_ = this.baseUrl + '/roles?';
    if (metadata !== undefined)
      url_ += 'metadata=' + encodeURIComponent('' + metadata) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processFindAllUsingGET(_response)
        );
      });
  }

  protected processFindAllUsingGET(
    response: Response
  ): Promise<SwaggerResponse<ResourceListOfRoleDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ResourceListOfRoleDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ResourceListOfRoleDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * creates a new role in PSL
   * @role role
   * @return OK
   */
  saveRoleUsingPOST(role: RoleDto): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/roles';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(role);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processSaveRoleUsingPOST(_response)
        );
      });
  }

  protected processSaveRoleUsingPOST(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result201);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * delete an existing role in PSL
   * @role role
   * @return role was deleted succesfully
   */
  deleteRoleUsingDELETE(role: RoleDto): Promise<SwaggerResponse<any>> {
    let url_ = this.baseUrl + '/roles';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(role);

    let options_ = <RequestInit>{
      body: content_,
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processDeleteRoleUsingDELETE(_response)
        );
      });
  }

  protected processDeleteRoleUsingDELETE(
    response: Response
  ): Promise<SwaggerResponse<any>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        let result204: any = null;
        result204 =
          _responseText === ''
            ? null
            : <any>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result204);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<any>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * updates an existing group in PSL
   * @role role
   * @return role was updated succesfully
   */
  updateRoleUsingPATCH(role: RoleDto): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/roles';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(role);

    let options_ = <RequestInit>{
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processUpdateRoleUsingPATCH(_response)
        );
      });
  }

  protected processUpdateRoleUsingPATCH(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * get a single role by given id
   * @id id
   * @metadata (optional) metadata
   * @return returns a role identified by given id
   */
  findByIdUsingGET(
    id: number,
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<RoleDto>> {
    let url_ = this.baseUrl + '/roles/{id}?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    if (metadata !== undefined)
      url_ += 'metadata=' + encodeURIComponent('' + metadata) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processFindByIdUsingGET(_response)
        );
      });
  }

  protected processFindByIdUsingGET(
    response: Response
  ): Promise<SwaggerResponse<RoleDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <RoleDto>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<RoleDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns all possible spec configurations
   * @return OK
   */
  getAllSpecsUsingGET(): Promise<
    SwaggerResponse<ResourceListOfSpecConfigurationDto>
  > {
    let url_ = this.baseUrl + '/specconfigurations';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetAllSpecsUsingGET(_response)
        );
      });
  }

  protected processGetAllSpecsUsingGET(
    response: Response
  ): Promise<SwaggerResponse<ResourceListOfSpecConfigurationDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ResourceListOfSpecConfigurationDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ResourceListOfSpecConfigurationDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * creates a new spec configuration
   * @dto dto
   * @return OK
   */
  saveSpecConfigurationUsingPOST(
    dto: SpecConfigurationDto
  ): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/specconfigurations';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(dto);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processSaveSpecConfigurationUsingPOST(_response)
        );
      });
  }

  protected processSaveSpecConfigurationUsingPOST(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result201);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * deletes an existing spec configuration
   * @dto dto
   * @return OK
   */
  deleteSpecConfigurationUsingDELETE(
    dto: SpecConfigurationDto
  ): Promise<SwaggerResponse<any>> {
    let url_ = this.baseUrl + '/specconfigurations';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(dto);

    let options_ = <RequestInit>{
      body: content_,
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processDeleteSpecConfigurationUsingDELETE(_response)
        );
      });
  }

  protected processDeleteSpecConfigurationUsingDELETE(
    response: Response
  ): Promise<SwaggerResponse<any>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <any>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        let result204: any = null;
        result204 =
          _responseText === ''
            ? null
            : <any>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result204);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<any>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * updates an existing spec configuration
   * @dto dto
   * @return spec configuration was updated successfully
   */
  updateSpecConfigurationUsingPATCH(
    dto: SpecConfigurationDto
  ): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/specconfigurations';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(dto);

    let options_ = <RequestInit>{
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processUpdateSpecConfigurationUsingPATCH(_response)
        );
      });
  }

  protected processUpdateSpecConfigurationUsingPATCH(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns a spec configuration with the given ID
   * @id id
   * @return Spec configuration with given ID was found
   */
  getSpecConfigByIdUsingGET(
    id: number
  ): Promise<SwaggerResponse<SpecConfigurationDto>> {
    let url_ = this.baseUrl + '/specconfigurations/{id}';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetSpecConfigByIdUsingGET(_response)
        );
      });
  }

  protected processGetSpecConfigByIdUsingGET(
    response: Response
  ): Promise<SwaggerResponse<SpecConfigurationDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <SpecConfigurationDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SpecConfigurationDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns a list with all specs
   * @metadata (optional) metadata
   * @return request was successfully completed
   */
  getAllSpecsUsingGET_1(
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfSpecDto>> {
    let url_ = this.baseUrl + '/specs?';
    if (metadata !== undefined)
      url_ += 'metadata=' + encodeURIComponent('' + metadata) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetAllSpecsUsingGET_1(_response)
        );
      });
  }

  protected processGetAllSpecsUsingGET_1(
    response: Response
  ): Promise<SwaggerResponse<ResourceListOfSpecDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ResourceListOfSpecDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ResourceListOfSpecDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * create a new spec
   * @spec spec
   * @return OK
   */
  createSpecUsingPOST(spec: SpecDto): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/specs';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(spec);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processCreateSpecUsingPOST(_response)
        );
      });
  }

  protected processCreateSpecUsingPOST(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * delete spec
   * @spec spec
   * @return OK
   */
  deleteSpecUsingDELETE(spec: SpecDto): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/specs';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(spec);

    let options_ = <RequestInit>{
      body: content_,
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processDeleteSpecUsingDELETE(_response)
        );
      });
  }

  protected processDeleteSpecUsingDELETE(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * update a spec
   * @spec spec
   * @return OK
   */
  updateSpecUsingPATCH(spec: SpecDto): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/specs';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(spec);

    let options_ = <RequestInit>{
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processUpdateSpecUsingPATCH(_response)
        );
      });
  }

  protected processUpdateSpecUsingPATCH(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * get a single spec by given id
   * @id id
   * @metadata (optional) metadata
   * @return returns a spec identified by given id
   */
  findByIdUsingGET_1(
    id: number,
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<SpecDto>> {
    let url_ = this.baseUrl + '/specs/{id}?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    if (metadata !== undefined)
      url_ += 'metadata=' + encodeURIComponent('' + metadata) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processFindByIdUsingGET_1(_response)
        );
      });
  }

  protected processFindByIdUsingGET_1(
    response: Response
  ): Promise<SwaggerResponse<SpecDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <SpecDto>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<SpecDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * acts as entry-point to the support area. Returns all sub-entrypoints for the support area pages
   * @return OK
   */
  getSupportAreaUsingGET(): Promise<SwaggerResponse<MenuDto>> {
    let url_ = this.baseUrl + '/support';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetSupportAreaUsingGET(_response)
        );
      });
  }

  protected processGetSupportAreaUsingGET(
    response: Response
  ): Promise<SwaggerResponse<MenuDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <MenuDto>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<MenuDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns all technical data from PCCD for the given context
   * @cnr cnr
   * @btyp btyp
   * @modelyear modelyear
   * @return OK
   */
  getTechnicalDataUsingGET(
    cnr: string,
    btyp: string,
    modelyear: string
  ): Promise<SwaggerResponse<TechnicalDataDto[]>> {
    let url_ = this.baseUrl + '/technicaldata?';
    if (cnr === undefined || cnr === null)
      throw new Error(
        "The parameter 'cnr' must be defined and cannot be null."
      );
    else url_ += 'cnr=' + encodeURIComponent('' + cnr) + '&';
    if (btyp === undefined || btyp === null)
      throw new Error(
        "The parameter 'btyp' must be defined and cannot be null."
      );
    else url_ += 'btyp=' + encodeURIComponent('' + btyp) + '&';
    if (modelyear === undefined || modelyear === null)
      throw new Error(
        "The parameter 'modelyear' must be defined and cannot be null."
      );
    else url_ += 'modelyear=' + encodeURIComponent('' + modelyear) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetTechnicalDataUsingGET(_response)
        );
      });
  }

  protected processGetTechnicalDataUsingGET(
    response: Response
  ): Promise<SwaggerResponse<TechnicalDataDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <TechnicalDataDto[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === ''
            ? null
            : <TechnicalDataDto[]>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result201);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 500) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<TechnicalDataDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns all typefamilies that are known in PSL for the given modelyear
   * @modelyearId modelyearId
   * @metadata (optional) metadata
   * @return OK
   */
  getTypeFamiliesUsingGET(
    modelyearId: number,
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfTypefamilyDto>> {
    let url_ = this.baseUrl + '/typefamilies/{modelyearId}?';
    if (modelyearId === undefined || modelyearId === null)
      throw new Error("The parameter 'modelyearId' must be defined.");
    url_ = url_.replace('{modelyearId}', encodeURIComponent('' + modelyearId));
    if (metadata !== undefined)
      url_ += 'metadata=' + encodeURIComponent('' + metadata) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetTypeFamiliesUsingGET(_response)
        );
      });
  }

  protected processGetTypeFamiliesUsingGET(
    response: Response
  ): Promise<SwaggerResponse<ResourceListOfTypefamilyDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ResourceListOfTypefamilyDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ResourceListOfTypefamilyDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns all user that are known in PSL
   * @metadata (optional) metadata
   * @return request was successfully completed
   */
  getUsersUsingGET(
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfUserDto>> {
    let url_ = this.baseUrl + '/users?';
    if (metadata !== undefined)
      url_ += 'metadata=' + encodeURIComponent('' + metadata) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetUsersUsingGET(_response)
        );
      });
  }

  protected processGetUsersUsingGET(
    response: Response
  ): Promise<SwaggerResponse<ResourceListOfUserDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ResourceListOfUserDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ResourceListOfUserDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * creates a new user in PSL
   * @user user
   * @return OK
   */
  addUserUsingPOST(user: UserDto): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/users';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(user);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processAddUserUsingPOST(_response)
        );
      });
  }

  protected processAddUserUsingPOST(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result201);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * delete an existing user in PSL
   * @user user
   * @return user was deleted succesfully
   */
  deleteUserUsingDELETE(user: UserDto): Promise<SwaggerResponse<any>> {
    let url_ = this.baseUrl + '/users';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(user);

    let options_ = <RequestInit>{
      body: content_,
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processDeleteUserUsingDELETE(_response)
        );
      });
  }

  protected processDeleteUserUsingDELETE(
    response: Response
  ): Promise<SwaggerResponse<any>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 204) {
      return response.text().then((_responseText) => {
        let result204: any = null;
        result204 =
          _responseText === ''
            ? null
            : <any>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result204);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<any>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * updates an existing user in PSL
   * @user user
   * @return user was updated succesfully
   */
  updateUserUsingPATCH(user: UserDto): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/users';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(user);

    let options_ = <RequestInit>{
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processUpdateUserUsingPATCH(_response)
        );
      });
  }

  protected processUpdateUserUsingPATCH(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * get optionTypes available ofr a user from the groups that he is assigned to.
   * @cn cn
   * @return returns the list of option types from the user groups
   */
  getUserGroupsOptionTypesUsingGET(
    cn: string
  ): Promise<SwaggerResponse<Anonymous[]>> {
    let url_ = this.baseUrl + '/users/groups/optiontypes/{cn}';
    if (cn === undefined || cn === null)
      throw new Error("The parameter 'cn' must be defined.");
    url_ = url_.replace('{cn}', encodeURIComponent('' + cn));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetUserGroupsOptionTypesUsingGET(_response)
        );
      });
  }

  protected processGetUserGroupsOptionTypesUsingGET(
    response: Response
  ): Promise<SwaggerResponse<Anonymous[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Anonymous[]>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Anonymous[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * fetches all roles (user roles + user group roles) for a given user.
   * @userCn userCn
   * @return returns a list with all possible roles for the given user.
   */
  getAllRolesForUserUsingGET(
    userCn: string
  ): Promise<SwaggerResponse<RoleDto[]>> {
    let url_ = this.baseUrl + '/users/roles/{userCn}';
    if (userCn === undefined || userCn === null)
      throw new Error("The parameter 'userCn' must be defined.");
    url_ = url_.replace('{userCn}', encodeURIComponent('' + userCn));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetAllRolesForUserUsingGET(_response)
        );
      });
  }

  protected processGetAllRolesForUserUsingGET(
    response: Response
  ): Promise<SwaggerResponse<RoleDto[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <RoleDto[]>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        let result204: any = null;
        result204 =
          _responseText === ''
            ? null
            : <RoleDto[]>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result204);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<RoleDto[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * updates the user-settings for an existing user
   * @user user
   * @return user was updated succesfully
   */
  updateUserSettingsUsingPATCH(user: UserDto): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/users/updateSettings';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(user);

    let options_ = <RequestInit>{
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processUpdateUserSettingsUsingPATCH(_response)
        );
      });
  }

  protected processUpdateUserSettingsUsingPATCH(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns a single user
   * @cn cn
   * @metadata (optional) metadata
   * @return request was successfully completed
   */
  getUserUsingGET(
    cn: string,
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<UserDto>> {
    let url_ = this.baseUrl + '/users/{cn}?';
    if (cn === undefined || cn === null)
      throw new Error("The parameter 'cn' must be defined.");
    url_ = url_.replace('{cn}', encodeURIComponent('' + cn));
    if (metadata !== undefined)
      url_ += 'metadata=' + encodeURIComponent('' + metadata) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetUserUsingGET(_response)
        );
      });
  }

  protected processGetUserUsingGET(
    response: Response
  ): Promise<SwaggerResponse<UserDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <UserDto>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<UserDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * get user details from LDAP
   * @cn cn
   * @return returns the detailed user-info from LDAP
   */
  getUserLdapDetailsUsingGET(
    cn: string
  ): Promise<SwaggerResponse<UserDetailsDto>> {
    let url_ = this.baseUrl + '/users/{cn}/details';
    if (cn === undefined || cn === null)
      throw new Error("The parameter 'cn' must be defined.");
    url_ = url_.replace('{cn}', encodeURIComponent('' + cn));
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetUserLdapDetailsUsingGET(_response)
        );
      });
  }

  protected processGetUserLdapDetailsUsingGET(
    response: Response
  ): Promise<SwaggerResponse<UserDetailsDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <UserDetailsDto>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<UserDetailsDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns a list with all specs
   * @return request was successfully completed
   */
  getVersionInfoUsingGET(): Promise<SwaggerResponse<VersionInfoDto>> {
    let url_ = this.baseUrl + '/version';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetVersionInfoUsingGET(_response)
        );
      });
  }

  protected processGetVersionInfoUsingGET(
    response: Response
  ): Promise<SwaggerResponse<VersionInfoDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <VersionInfoDto>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<VersionInfoDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns a list with all workflows
   * @metadata (optional) metadata
   * @return request was successfully completed
   */
  getAllWorkflowsUsingGET(
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfWorkflowDto>> {
    let url_ = this.baseUrl + '/workflows?';
    if (metadata !== undefined)
      url_ += 'metadata=' + encodeURIComponent('' + metadata) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetAllWorkflowsUsingGET(_response)
        );
      });
  }

  protected processGetAllWorkflowsUsingGET(
    response: Response
  ): Promise<SwaggerResponse<ResourceListOfWorkflowDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ResourceListOfWorkflowDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ResourceListOfWorkflowDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * creates a new workflow
   * @workflow workflow
   * @return OK
   */
  addWorkflowUsingPOST(workflow: WorkflowDto): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/workflows';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(workflow);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processAddWorkflowUsingPOST(_response)
        );
      });
  }

  protected processAddWorkflowUsingPOST(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        let result201: any = null;
        result201 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result201);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 409) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * delete an existing workflow in PSL
   * @workflow workflow
   * @return OK
   */
  deleteWorkflowUsingDELETE(
    workflow: WorkflowDto
  ): Promise<SwaggerResponse<any>> {
    let url_ = this.baseUrl + '/workflows';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(workflow);

    let options_ = <RequestInit>{
      body: content_,
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processDeleteWorkflowUsingDELETE(_response)
        );
      });
  }

  protected processDeleteWorkflowUsingDELETE(
    response: Response
  ): Promise<SwaggerResponse<any>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <any>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        let result204: any = null;
        result204 =
          _responseText === ''
            ? null
            : <any>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result204);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<any>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * updates an existing workflow
   * @workflow workflow
   * @return workflow was updated succesfully
   */
  updateWorkflowUsingPATCH(
    workflow: WorkflowDto
  ): Promise<SwaggerResponse<Link>> {
    let url_ = this.baseUrl + '/workflows';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(workflow);

    let options_ = <RequestInit>{
      body: content_,
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processUpdateWorkflowUsingPATCH(_response)
        );
      });
  }

  protected processUpdateWorkflowUsingPATCH(
    response: Response
  ): Promise<SwaggerResponse<Link>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <Link>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<Link>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns a list with all workflow-groups that can be approved for the current user
   * @return request was successfully completed
   */
  getAllWorkflowApprovalsUsingGET(): Promise<
    SwaggerResponse<ResourceListOfWorkflowOptionApprovalDto>
  > {
    let url_ = this.baseUrl + '/workflows/approval';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetAllWorkflowApprovalsUsingGET(_response)
        );
      });
  }

  protected processGetAllWorkflowApprovalsUsingGET(
    response: Response
  ): Promise<SwaggerResponse<ResourceListOfWorkflowOptionApprovalDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ResourceListOfWorkflowOptionApprovalDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<
      SwaggerResponse<ResourceListOfWorkflowOptionApprovalDto>
    >(new SwaggerResponse(status, _headers, <any>null));
  }

  /**
   * processes the given data and performs the next workflow-steps
   * @approvals approvals
   * @return OK
   */
  processWorkflowApprovalsUsingPOST(
    approvals: WorkflowOptionApprovalDto[]
  ): Promise<SwaggerResponse<any>> {
    let url_ = this.baseUrl + '/workflows/approval';
    url_ = url_.replace(/[?&]$/, '');

    const content_ = JSON.stringify(approvals);

    let options_ = <RequestInit>{
      body: content_,
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processProcessWorkflowApprovalsUsingPOST(_response)
        );
      });
  }

  protected processProcessWorkflowApprovalsUsingPOST(
    response: Response
  ): Promise<SwaggerResponse<any>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <any>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 201) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        let result204: any = null;
        result204 =
          _responseText === ''
            ? null
            : <any>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result204);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<any>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * sendReleventApprovalsEmail
   * @return OK
   */
  sendReleventApprovalsEmailUsingGET(): Promise<SwaggerResponse<any>> {
    let url_ = this.baseUrl + '/workflows/approval/send-email';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processSendReleventApprovalsEmailUsingGET(_response)
        );
      });
  }

  protected processSendReleventApprovalsEmailUsingGET(
    response: Response
  ): Promise<SwaggerResponse<any>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <any>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<any>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * empties the cache
   * @return OK
   */
  clearCacheUsingDELETE(): Promise<SwaggerResponse<any>> {
    let url_ = this.baseUrl + '/workflows/cache';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processClearCacheUsingDELETE(_response)
        );
      });
  }

  protected processClearCacheUsingDELETE(
    response: Response
  ): Promise<SwaggerResponse<any>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <any>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 204) {
      return response.text().then((_responseText) => {
        let result204: any = null;
        result204 =
          _responseText === ''
            ? null
            : <any>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result204);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<any>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns a map with the base option id as key and the corresponding available workflows as value
   * @typeFamily typeFamily
   * @optionBasicDtoIds optionBasicDtoIds
   * @return OK
   */
  getAvailableWorkflowsForOptionsUsingGET(
    typeFamily: number,
    optionBasicDtoIds: number[]
  ): Promise<SwaggerResponse<{ [key: string]: WorkflowDto[] }>> {
    let url_ = this.baseUrl + '/workflows/options?';
    if (typeFamily === undefined || typeFamily === null)
      throw new Error(
        "The parameter 'typeFamily' must be defined and cannot be null."
      );
    else url_ += 'typeFamily=' + encodeURIComponent('' + typeFamily) + '&';
    if (optionBasicDtoIds === undefined || optionBasicDtoIds === null)
      throw new Error(
        "The parameter 'optionBasicDtoIds' must be defined and cannot be null."
      );
    else
      optionBasicDtoIds &&
        optionBasicDtoIds.forEach((item) => {
          url_ += 'optionBasicDtoIds=' + encodeURIComponent('' + item) + '&';
        });
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetAvailableWorkflowsForOptionsUsingGET(_response)
        );
      });
  }

  protected processGetAvailableWorkflowsForOptionsUsingGET(
    response: Response
  ): Promise<SwaggerResponse<{ [key: string]: WorkflowDto[] }>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <{ [key: string]: WorkflowDto[] }>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<{ [key: string]: WorkflowDto[] }>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns a list with all partitions that are relevant for the given workflow-type
   * @workflowType workflowType
   * @return request was successfully completed
   */
  getWorkflowPartitionsUsingGET(
    workflowType: WorkflowType
  ): Promise<SwaggerResponse<string[]>> {
    let url_ = this.baseUrl + '/workflows/partitions?';
    if (workflowType === undefined || workflowType === null)
      throw new Error(
        "The parameter 'workflowType' must be defined and cannot be null."
      );
    else url_ += 'workflowType=' + encodeURIComponent('' + workflowType) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetWorkflowPartitionsUsingGET(_response)
        );
      });
  }

  protected processGetWorkflowPartitionsUsingGET(
    response: Response
  ): Promise<SwaggerResponse<string[]>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <string[]>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<string[]>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns a single workflow
   * @id id
   * @metadata (optional) metadata
   * @return request was successfully completed
   */
  getWorkflowByIdUsingGET(
    id: number,
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<WorkflowDto>> {
    let url_ = this.baseUrl + '/workflows/{id}?';
    if (id === undefined || id === null)
      throw new Error("The parameter 'id' must be defined.");
    url_ = url_.replace('{id}', encodeURIComponent('' + id));
    if (metadata !== undefined)
      url_ += 'metadata=' + encodeURIComponent('' + metadata) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetWorkflowByIdUsingGET(_response)
        );
      });
  }

  protected processGetWorkflowByIdUsingGET(
    response: Response
  ): Promise<SwaggerResponse<WorkflowDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <WorkflowDto>JSON.parse(_responseText, this.jsonParseReviver);
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<WorkflowDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * returns a list of options for the given context
   * @modelyearId modelyearId
   * @typefamilyId typefamilyId
   * @cnrId cnrId
   * @metadata (optional) metadata
   * @return OK
   */
  getOptionsUsingGET(
    modelyearId: number,
    typefamilyId: number,
    cnrId: number,
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfOptionDto>> {
    let url_ = this.baseUrl + '/{modelyearId}/options?';
    if (modelyearId === undefined || modelyearId === null)
      throw new Error("The parameter 'modelyearId' must be defined.");
    url_ = url_.replace('{modelyearId}', encodeURIComponent('' + modelyearId));
    if (typefamilyId === undefined || typefamilyId === null)
      throw new Error(
        "The parameter 'typefamilyId' must be defined and cannot be null."
      );
    else url_ += 'typefamilyId=' + encodeURIComponent('' + typefamilyId) + '&';
    if (cnrId === undefined || cnrId === null)
      throw new Error(
        "The parameter 'cnrId' must be defined and cannot be null."
      );
    else url_ += 'cnrId=' + encodeURIComponent('' + cnrId) + '&';
    if (metadata !== undefined)
      url_ += 'metadata=' + encodeURIComponent('' + metadata) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetOptionsUsingGET(_response)
        );
      });
  }

  protected processGetOptionsUsingGET(
    response: Response
  ): Promise<SwaggerResponse<ResourceListOfOptionDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ResourceListOfOptionDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ResourceListOfOptionDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * get all active modeltype basics by modelyear
   * @modelyear modelyear
   * @typeFamilyId (optional) typeFamilyId
   * @computePdipFlag (optional) computePdipFlag
   * @metadata (optional) metadata
   * @return returns modeltype basics for specified modelyear (and/or typefamily).
   */
  getModeltypeBasicsUsingGET(
    modelyear: number,
    typeFamilyId?: number | null | undefined,
    computePdipFlag?: boolean | null | undefined,
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfModeltypeBasicDto>> {
    let url_ = this.baseUrl + '/{modelyear}/modeltypeBasics?';
    if (modelyear === undefined || modelyear === null)
      throw new Error("The parameter 'modelyear' must be defined.");
    url_ = url_.replace('{modelyear}', encodeURIComponent('' + modelyear));
    if (typeFamilyId !== undefined)
      url_ += 'typeFamilyId=' + encodeURIComponent('' + typeFamilyId) + '&';
    if (computePdipFlag !== undefined)
      url_ +=
        'computePdipFlag=' + encodeURIComponent('' + computePdipFlag) + '&';
    if (metadata !== undefined)
      url_ += 'metadata=' + encodeURIComponent('' + metadata) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetModeltypeBasicsUsingGET(_response)
        );
      });
  }

  protected processGetModeltypeBasicsUsingGET(
    response: Response
  ): Promise<SwaggerResponse<ResourceListOfModeltypeBasicDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ResourceListOfModeltypeBasicDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 412) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ResourceListOfModeltypeBasicDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * get option basics by modelyear
   * @modelyear modelyear
   * @metadata (optional) metadata
   * @computePdipFlag (optional) computePdipFlag
   * @computePCCDFlag (optional) computePCCDFlag
   * @return returns option basics for specified modelyear
   */
  getByModelyearUsingGET(
    modelyear: number,
    metadata?: boolean | null | undefined,
    computePdipFlag?: boolean | null | undefined,
    computePCCDFlag?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfOptionBasicDto>> {
    let url_ = this.baseUrl + '/{modelyear}/optionBasics?';
    if (modelyear === undefined || modelyear === null)
      throw new Error("The parameter 'modelyear' must be defined.");
    url_ = url_.replace('{modelyear}', encodeURIComponent('' + modelyear));
    if (metadata !== undefined)
      url_ += 'metadata=' + encodeURIComponent('' + metadata) + '&';
    if (computePdipFlag !== undefined)
      url_ +=
        'computePdipFlag=' + encodeURIComponent('' + computePdipFlag) + '&';
    if (computePCCDFlag !== undefined)
      url_ +=
        'computePCCDFlag=' + encodeURIComponent('' + computePCCDFlag) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetByModelyearUsingGET(_response)
        );
      });
  }

  protected processGetByModelyearUsingGET(
    response: Response
  ): Promise<SwaggerResponse<ResourceListOfOptionBasicDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ResourceListOfOptionBasicDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 412) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ResourceListOfOptionBasicDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * get option basics by modelyear that have an approved state
   * @modelyear modelyear
   * @metadata (optional) metadata
   * @return returns option basics for specified modelyear
   */
  getApprovedByModelyearUsingGET(
    modelyear: number,
    metadata?: boolean | null | undefined
  ): Promise<SwaggerResponse<ResourceListOfOptionBasicDto>> {
    let url_ = this.baseUrl + '/{modelyear}/optionBasics/approved?';
    if (modelyear === undefined || modelyear === null)
      throw new Error("The parameter 'modelyear' must be defined.");
    url_ = url_.replace('{modelyear}', encodeURIComponent('' + modelyear));
    if (metadata !== undefined)
      url_ += 'metadata=' + encodeURIComponent('' + metadata) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetApprovedByModelyearUsingGET(_response)
        );
      });
  }

  protected processGetApprovedByModelyearUsingGET(
    response: Response
  ): Promise<SwaggerResponse<ResourceListOfOptionBasicDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ResourceListOfOptionBasicDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 400) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 412) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ResourceListOfOptionBasicDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }

  /**
   * get all active modeltype basics by modelyear and typefamily
   * @modelyear modelyear
   * @typeFamilyId typeFamilyId
   * @cnrId cnrId
   * @return returns modeltype basics for specified modelyear and typefamily
   */
  getModeltypeBasicsForPSLUsingGET(
    modelyear: number,
    typeFamilyId: number,
    cnrId: number
  ): Promise<SwaggerResponse<ResourceListOfModeltypeBasicDto>> {
    let url_ = this.baseUrl + '/{modelyear}/psl/modeltypeBasics?';
    if (modelyear === undefined || modelyear === null)
      throw new Error("The parameter 'modelyear' must be defined.");
    url_ = url_.replace('{modelyear}', encodeURIComponent('' + modelyear));
    if (typeFamilyId === undefined || typeFamilyId === null)
      throw new Error(
        "The parameter 'typeFamilyId' must be defined and cannot be null."
      );
    else url_ += 'typeFamilyId=' + encodeURIComponent('' + typeFamilyId) + '&';
    if (cnrId === undefined || cnrId === null)
      throw new Error(
        "The parameter 'cnrId' must be defined and cannot be null."
      );
    else url_ += 'cnrId=' + encodeURIComponent('' + cnrId) + '&';
    url_ = url_.replace(/[?&]$/, '');

    let options_ = <RequestInit>{
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        Accept: '*/*',
      },
    };

    return this.transformOptions(options_)
      .then((transformedOptions_) => {
        return this.http.fetch(url_, transformedOptions_);
      })
      .then((_response: Response) => {
        return this.transformResult(url_, _response, (_response: Response) =>
          this.processGetModeltypeBasicsForPSLUsingGET(_response)
        );
      });
  }

  protected processGetModeltypeBasicsForPSLUsingGET(
    response: Response
  ): Promise<SwaggerResponse<ResourceListOfModeltypeBasicDto>> {
    const status = response.status;
    let _headers: any = {};
    if (response.headers && response.headers.forEach) {
      response.headers.forEach((v: any, k: any) => (_headers[k] = v));
    }
    if (status === 200) {
      return response.text().then((_responseText) => {
        let result200: any = null;
        result200 =
          _responseText === ''
            ? null
            : <ResourceListOfModeltypeBasicDto>(
                JSON.parse(_responseText, this.jsonParseReviver)
              );
        return new SwaggerResponse(status, _headers, result200);
      });
    } else if (status === 401) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 403) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status === 404) {
      return response.text().then((_responseText) => {
        return throwException(
          'A server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    } else if (status !== 200 && status !== 204) {
      return response.text().then((_responseText) => {
        return throwException(
          'An unexpected server error occurred.',
          status,
          _responseText,
          _headers
        );
      });
    }
    return Promise.resolve<SwaggerResponse<ResourceListOfModeltypeBasicDto>>(
      new SwaggerResponse(status, _headers, <any>null)
    );
  }
}

export interface AssignedGroupRoleDto {
  group?: GroupDto | undefined;
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  objectId: number;
  role?: RoleDto | undefined;
  versionId: number;
}

export interface AssignedModeltypeBasicDto {
  assignmentType: AssignedModeltypeBasicDtoAssignmentType;
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  missingPDiPAssignment?: boolean | undefined;
  modeltypeBasic: ModeltypeBasicDto;
  objectId: number;
  option?: SimpleOptionDto | undefined;
  versionId: number;
}

export interface AssignedUserRoleDto {
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  objectId: number;
  role?: RoleDto | undefined;
  user?: UserDto | undefined;
  versionId: number;
}

export interface AssignmentTransferDto {
  links?: Link[] | undefined;
  options: OptionDto[];
  sourceMTB: ModeltypeBasicDto;
  targetMTBs: ModeltypeBasicDto[];
}

export interface UpdateDraftAssignmentsDto {
  links?: Link[] | undefined;
  options: OptionTransferDto[];
  derivates: ModeltypeBasicDto[];
}

export interface CategoryTextDto {
  categoryCode: string;
  languageId: number;
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  modeltypeBasicId?: number | undefined;
  modelyearId: number;
  objectId: number;
  proMTSequence: number;
  sequenceNo: number;
  text: string;
  versionId: number;
}

export interface LanguageCnrDto {
  cnr: CnrDto;
  assignedLanguages?: LanguageDto[] | undefined;
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  versionId: number;
}

export interface CategoryTextSortDto {
  categoryCode: string;
  modelyearId: number;
  proMTSequence: number;
  sequenceNo: number;
  textEN: string;
  textDE: string;
}

export interface CnrDto {
  cnr: string;
  hasPSLAssigned?: boolean | undefined;
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  name: string;
  objectId: number;
  versionId: number;
  region?:RegionDto;
}

export interface CnrExtDto {
  cnr?: string | undefined;
  name?: string | undefined;
  promtId?: string | undefined;
}

export interface DifferenceDtoOfAssignedModeltypeBasicDto {
  differenceA?: AssignedModeltypeBasicDto | undefined;
  differenceB?: AssignedModeltypeBasicDto | undefined;
}

export interface DifferenceDtoOfListOfstring {
  differenceA?: string[] | undefined;
  differenceB?: string[] | undefined;
}

export interface DifferenceDtoOfOptionWorkflowStatusDifferenceDto {
  differenceA?: OptionWorkflowStatusDifferenceDto | undefined;
  differenceB?: OptionWorkflowStatusDifferenceDto | undefined;
}

export interface DifferenceDtoOfdouble {
  differenceA?: number | undefined;
  differenceB?: number | undefined;
}

export interface DifferenceDtoOflong {
  differenceA?: number | undefined;
  differenceB?: number | undefined;
}

export interface DifferenceDtoOfstring {
  differenceA?: string | undefined;
  differenceB?: string | undefined;
}

export interface DtoListWithLinksOfOptionDto {
  links?: Link[] | undefined;
  list: OptionDto[];
}

export interface ExcelDownloadResponseDto {
  base64Response?: string | undefined;
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  objectId: number;
  versionId: number;
}

export interface ExcelExportResponseDto {
  fileName?: string | undefined;
  filePath?: string | undefined;
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  objectId: number;
  versionId: number;
}

export interface ExcelPropsDto {
  cnr: CnrDto;
  excelVisibleColumns: ExcelVisibleColumns[];
  links?: Link[] | undefined;
  modeltypeBasicList: ModeltypeBasicDto[];
  modelyear: ModelyearDto;
  optionDtos: OptionDto[];
  typefamily: TypefamilyDto;
  selectedLanguages: number[];
  filters?:any;
}

export interface FrontendError {
  errorType?: string | undefined;
  stack?: string | undefined;
  timestamp?: string | undefined;
}

export interface GroupDetailsDto {
  groupName?: string | undefined;
  member?: string[] | undefined;
  parentGroups?: string[] | undefined;
}

export interface GroupDto {
  assignedRoles?: AssignedGroupRoleDto[] | undefined;
  assignedModelyears?: ModelyearDto[] | undefined;
  assignedTypefamilies?: TypefamilyDto[] | undefined;
  assignedCnrs?: CnrDto[] | undefined;
  groupName: string;
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  objectId: number;
  optionTypes?: string | undefined;
  versionId: number;
}

export interface ProMTGroupDto {
    assignedRoles?: RoleDto[] | undefined;
    assignedUsers?: UserDto[] | undefined;
    assignedGroups?: GroupDto[] | undefined;
    assignedModelyears?: ModelyearDto[] | undefined;
    assignedTypefamilies?: TypefamilyDto[] | undefined;
    assignedCnrs?: CnrDto[] | undefined;
    groupName: string;
    links?: Link[] | undefined;
    metadata?: Metadata | undefined;
    objectId: number;
    optionTypes?: string | undefined;
    versionId: number;
}

export interface ImmutablePairOflongAndlong {
  key?: number | undefined;
  left?: number | undefined;
  right?: number | undefined;
  value?: number | undefined;
}

export interface ImporterDto {
  importer: string;
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  name: string;
  objectId: number;
  versionId: number;
}

export interface ImporterExtDto {
  cnr?: string | undefined;
  furtherSpecs?: string | undefined;
  importers?: string[] | undefined;
  message?: string | undefined;
  typification?: string | undefined;
}

export interface InitDto {
  basicMarketCnr?: CnrDto | undefined;
  cnrs?: ResourceListOfCnrDto | undefined;
  userCnrs?: ResourceListOfCnrDto | undefined;
  languages?: ResourceListOfLanguageDto | undefined;
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  modelyears?: ResourceListOfModelyearDto | undefined;
  userModelyears?: ResourceListOfModelyearDto | undefined;
  objectId: number;
  openApprovalsCount?: number | undefined;
  typefamilies?: { [key: string]: ResourceListOfTypefamilyDto } | undefined;
  userTypefamilies?: { [key: string]: ResourceListOfTypefamilyDto } | undefined;
  userDetails?: UserDetailsDto | undefined;
  userInfo?: UserDto | undefined;
  userRoles?: RoleDto[] | undefined;
  versionId: number;
  versionInfo?: VersionInfoDto | undefined;
  workflows?: ResourceListOfWorkflowDto | undefined;
}

export interface LanguageDto {
  code: string;
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  nameDe: string;
  nameEn: string;
  vmce: string;
  objectId: number;
  versionId: number;
}

export interface OBCategoriesDto {
  serCategories: CategoryTextDto[];
  nonSerCategories: CategoryTextDto[];
}

export interface Link {
  href?: string | undefined;
  rel?: string | undefined;
  templated?: boolean | undefined;
}

export interface MenuDto {
  links?: Link[] | undefined;
}

export interface JobsDto {
  active:boolean;
  name:string;
  objectId:number;
  linkedSystem:string;
  versionId:number;
  modelYears:ModelyearDto[];
  lastUpdatedByJob?:any;
  updatedBy?:string;
  status?:string;
  lastSuccessOn?:any;
}

export interface Metadata {
  changedBy?: string | undefined;
  changedTimestamp?: number | undefined;
  createdTimestamp?: number | undefined;
  links?: Link[] | undefined;
}

export interface ModelAndView {
  empty?: boolean | undefined;
  model?: any | undefined;
  modelMap?: { [key: string]: any } | undefined;
  reference?: boolean | undefined;
  status?: ModelAndViewStatus | undefined;
  view?: View | undefined;
  viewName?: string | undefined;
}

export interface ModeltypeBasicCopyDto {
  links?: Link[] | undefined;
  sourceModelyearId: number;
  sourceTypefamilyId: number;
  targetModelyearId: number;
  targetTypefamilyId: number;
  withSequence?: boolean | undefined;
}

export interface ModeltypeBasicDto {
  active?: boolean | undefined;
  btyp?: string | undefined;
  color?: string | undefined;
  hasTechData: boolean;
  intSequence?: number | undefined;
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  modelyear: ModelyearDto;
  names?: ModelBasicNameDto[] | undefined;
  objectId: number;
  pdipFlag?: boolean | undefined;
  typefamily: TypefamilyDto;
  versionId: number;
  textExportDate?: Date;
  textExportStatus?: string;
  pccdFlag?: boolean;
  assignmentType?:string;
  visible: boolean;
  generation:OSPGenerationDto;
}
export interface OSPGenerationDto {
  generation:string;
  objectId:number;
}
export interface ModelBasicNameDto {
  name?: string | undefined;
  language: SimpleLanguageDto;
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  objectId: number;
  versionId: number;
}

export interface ModeltypeBasicExtDto {
  active?: boolean | undefined;
  btyp?: string | undefined;
  modelyear?: string | undefined;
  name?: string | undefined;
  promtId?: string | undefined;
  typefamily?: string | undefined;
}

export interface ModelyearDto {
  hasPSLAssigned?: boolean | undefined;
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  mj1: string;
  mj4: number;
  objectId: number;
  versionId: number;
}

export interface ModelyearExtDto {
  my1?: string | undefined;
  promtId?: string | undefined;
}

export interface NewsDto {
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  title: string;
  content: string;
  objectId: number;
  versionId: number;
  sequence?: number;
  active?: boolean;
  priority?: ENewsPriority;
}

export interface FaqDto {
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  question: string;
  answer: string;
  objectId: number;
  versionId: number;
  sequence?: number;
  active: boolean;
}

export interface OptionBasicCoreDto {
  objectId: number;
  optionCode: string;
  optionType: OptionBasicCoreDtoOptionType;
  pccdPackageContent: string;
}

export interface OptionBasicDto {
  businessId?: number | undefined;
  category: string;
  categoryText: CategoryTextDto;
  comment?: string | undefined;
  intSequence?: number | undefined;
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  modelyear: ModelyearDto;
  objectId: number;
  optionCode: string;
  optionCount?: number | undefined;
  optionType: OptionBasicDtoOptionType;
  partNumber?: string | undefined;
  pdipFlag?: boolean | undefined;
  pccdFlag?: boolean | undefined;
  pdipMFamilie?: string | undefined;
  pdipMFamilieBez?: string | undefined;
  status: string;
  textExportDate?: Date | undefined;
  textExportStatus?: OptionBasicDtoTextExportStatus | undefined;
  texts: OptionBasicTextDto[];
  optionBasicTextPCCDExports?: any;
  versionId: number;
  pccdCategoryOverride?: boolean;
  pccdIntSequenceOverride?: boolean;
  pdiptext?:string;
}

export interface OptionBasicReferenceDto {
  typefamilyId: number;
  typefamilyName: string;
  sortOrder: number;
  optionTexts: OptionTextDto[] | undefined;
  generation? : string
}

export interface OptionBasicExtDto {
  code?: string | undefined;
  modelyear?: string | undefined;
  promtId?: string | undefined;
  shortTextDE?: string | undefined;
  shortTextEN?: string | undefined;
  type?: string | undefined;
}

export interface OptionBasicMYCopyConflictDto {
  foundOBInTarget: boolean;
  obInitialized: boolean;
  sourceOBSimple: OptionBasicSimpleDto;
  targetOBSimple?: OptionBasicSimpleDto | undefined;
  wfStarted: boolean;
  sourceDuplicate: boolean;
  targetDuplicate: boolean;
}

export interface OptionBasicMYCopyDto {
  links?: Link[] | undefined;
  sourceModelyearId: number;
  sourceOBsForOverwrite?: OptionBasicMYCopyConflictDto[] | undefined;
  targetModelyearId: number;
}

export interface OptionBasicMYCopySummaryDto {
  copiedWithOverwriteOBs?: number[] | undefined;
  copiedWithoutConflictOBs?: number[] | undefined;
  errorOBs?: number[] | undefined;
  inConflictOBs?: number[] | undefined;
  toProcessOBs?: number[] | undefined;
}

export interface OptionBasicPSLDependencyDto {
  constraintPSLs: { [key: string]: number };
  exclusionPSLs: { [key: string]: number };
  packageContentPSLs: { [key: string]: number };
}

export interface OptionBasicSimpleDto {
  modelyear: ModelyearDto;
  objectId: number;
  optionCode: string;
  optionType: OptionBasicSimpleDtoOptionType;
  texts: OptionBasicTextDto[];
}

export interface OptionBasicTextDto {
  languageDto?: LanguageDto | undefined;
  links?: Link[] | undefined;
  longtext?: string | undefined;
  metadata?: Metadata | undefined;
  objectId: number;
  optionBasicDto?: OptionBasicDto | undefined;
  shorttext?: string | undefined;
  versionId: number;
  aiGeneratedShorttext?: boolean;
  aiGeneratedLongtext?: boolean;
}

export interface OptionBasicTextPCCDExportDto {
  languageDto?: LanguageDto | undefined;
  longtext?: string | undefined;
  objectId: number;
  optionBasicDto?: OptionBasicDto | undefined;
  shorttext?: string | undefined;
  versionId: number;
}

export interface OptionDifferenceDto {
  availableEnd?: DifferenceDtoOfstring | undefined;
  availableStart?: DifferenceDtoOfstring | undefined;
  comment?: DifferenceDtoOfstring | undefined;
  constraint?: DifferenceDtoOfListOfstring | undefined;
  exclusion?: DifferenceDtoOfListOfstring | undefined;
  footer?: OptionTextDifferenceDto | undefined;
  intsequence?: DifferenceDtoOflong | undefined;
  longText?: OptionTextDifferenceDto | undefined;
  modeltypes?: DifferenceDtoOfAssignedModeltypeBasicDto[] | undefined;
  optionCode: string;
  optionType: OptionDifferenceDtoOptionType;
  packageContent?: DifferenceDtoOfListOfstring | undefined;
  price?: DifferenceDtoOfdouble | undefined;
  reference?: DifferenceDtoOfstring | undefined;
  referenceExc?: DifferenceDtoOfstring | undefined;
  shortText?: OptionTextDifferenceDto | undefined;
  status?: DifferenceDtoOfOptionWorkflowStatusDifferenceDto | undefined;
  usp?: OptionTextDifferenceDto | undefined;
}

export interface OptionDto {
  availableEnd?: string | undefined;
  availableStart?: string | undefined;
  cnrId: number;
  comment?: string | undefined;
  constraint?: OptionBasicCoreDto[] | undefined;
  exclusion?: OptionBasicCoreDto[] | undefined;
  flags?: FlagDto[] | undefined;
  hasSpecificCopy?: boolean | undefined;
  importerId: number;
  intSequence?: number | undefined;
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  modeltypes?: AssignedModeltypeBasicDto[] | undefined;
  objectId: number;
  optionBasic: OptionBasicDto;
  packageContent?: OptionBasicCoreDto[] | undefined;
  parentId?: number | undefined;
  parentTexts?: OptionTextDto[] | undefined;
  pdipFlag?: boolean | undefined;
  pccdFlag?: boolean | undefined;
  price?: number | undefined;
  reference?: string | undefined;
  referenceExc?: string | undefined;
  referencedOptionCount: number;
  rejectedStates?: RejectedApprovalDto[] | undefined;
  specificType?: OptionDtoSpecificType | undefined;
  status: string;
  textExportDate?: Date | undefined;
  textExportStatus?: OptionDtoTextExportStatus | undefined;
  textExportStatusMessage?: string | undefined;
  texts?: OptionTextDto[] | undefined;
  optionTextPCCDExports?: OptionTextPCCDExportDto[];
  typefamilyId: number;
  versionId: number;
  isChecked?:boolean;
}

export interface OptionExtDto {
  cnr?: string | undefined;
  code?: string | undefined;
  constraint?: TypeCodeDto[] | undefined;
  derivatives?: string[] | undefined;
  exclusion?: TypeCodeDto[] | undefined;
  longTextDE?: string | undefined;
  longTextEN?: string | undefined;
  modelyear?: string | undefined;
  promtId?: string | undefined;
  type?: string | undefined;
  typefamily?: string | undefined;
}

export interface OptionFilterDto {
  availableEndFilter?: number | undefined;
  availableStartFilter?: number | undefined;
  categoryTextFilter?: string | undefined;
  cnrIdFilter?: number | undefined;
  commentFilter?: string | undefined;
  constraintFilter?: string | undefined;
  exclusionFilter?: string | undefined;
  footerFilter?: string | undefined;
  longtextFilter?: string | undefined;
  modelyearIdFilter?: number | undefined;
  optionBasicIdFilter?: number | undefined;
  optionCodeFilter?: string | undefined;
  optionTypeFilter?: string | undefined;
  priceFilter?: string | undefined;
  referenceExcFilter?: string | undefined;
  referenceFilter?: string | undefined;
  sequenceFilter?: string | undefined;
  shorttextFilter?: string | undefined;
  typefamilyIdFilter?: number | undefined;
  uspFilter?: string | undefined;
  workflowStepTypeFilter?: string | undefined;
  selectedLanguages?: number[];
}

export interface OptionInitDto {
  links?: Link[] | undefined;
  optionBasicWorkflows: { [key: string]: number };
  typefamilyId: number;
}

export interface OptionTextDifferenceDto {
  deText?: DifferenceDtoOfstring | undefined;
  enText?: DifferenceDtoOfstring | undefined;
}

export interface OptionTextDto {
  footer?: string | undefined;
  language?: SimpleLanguageDto | undefined;
  links?: Link[] | undefined;
  longtext?: string | undefined;
  metadata?: Metadata | undefined;
  objectId: number;
  option?: SimpleOptionDto | undefined;
  shorttext?: string | undefined;
  usp?: string | undefined;
  versionId: number;
  aiGeneratedShorttext?:boolean;
  aiGeneratedLongtext?:boolean;
  aiGeneratedFooter?:boolean;
  aiGeneratedUsp?:boolean;
}

export interface OptionTextPCCDExportDto {
  languageDto?: LanguageDto | undefined;
  longtext?: string | undefined;
  objectId: number;
  optionBasicDto?: OptionBasicDto | undefined;
  shorttext?: string | undefined;
  versionId: number;
}

export interface OptionTransferDto {
  optionDto: OptionDto;
  resetFlag: boolean;
}

export interface OptionUpdateDto {
  links?: Link[] | undefined;
  option?: OptionDto | undefined;
  updatedColumn?: string | undefined;
}

export interface CategoryTextSortUpdateDto {
  links?: Link[] | undefined;
  categoryTextSortDto?: CategoryTextSortDto[] | undefined;
  toPosition?: number | undefined;
}

export interface OptionWorkflowStatusDifferenceDto {
  name?: string | undefined;
  rejectMessage?: string | undefined;
  rejected?: boolean | undefined;
  type?: OptionWorkflowStatusDifferenceDtoType | undefined;
}

export interface OptionWorkflowStatusMultiUpdateParam {
  actionType: OptionWorkflowStatusMultiUpdateParamActionType;
  links?: Link[] | undefined;
  optionDtoList: OptionDto[];
}
export interface OptionFlagMultiUpdateParam {
  actionType :OptionFlagMultiUpdateParamActionType;
  links?: Link[] | undefined;
  options:UpdateFlagOption[];
  flags:FlagDto[];
}
export interface UpdateFlagOption {
  objectId:number;
  versionId:number;
}
export interface PDiPModeltypebasicDto {
  btyp: string;
  mj4: number;
  name?: string | undefined;
  typefamily: string;
}

export interface PDiPOptionBasicDto {
  mfamilie?: string | undefined;
  mfamilieBez?: string | undefined;
  optionCode: string;
  shorttextDe?: string | undefined;
}

export interface PSLCopyConflictDto {
  cnr: CnrDto;
  objectId: number;
  optionCode: string;
  optionType: PSLCopyConflictDtoOptionType;
  specificChildrenCount: number;
  texts: OptionTextDto[];
}

export interface PSLCopyResultSummaryDto {
  copiedBMOptions?: ImmutablePairOflongAndlong[] | undefined;
  copiedBasicOptions?: ImmutablePairOflongAndlong[] | undefined;
  copiedSMOptions?: ImmutablePairOflongAndlong[] | undefined;
  errorBMOptions?: number[] | undefined;
  errorSMOptions?: number[] | undefined;
  inConflictBMOptions?: number[] | undefined;
  toProcessBMOptions?: number[] | undefined;
  toProcessSMOptions?: number[] | undefined;
}

export interface PrivilegeDto {
  descriptionDe: string;
  descriptionEn: string;
  identifier: string;
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  objectId: number;
  versionId: number;
}

export interface RejectedApprovalDto {
  active?: boolean | undefined;
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  objectId: number;
  optionId?: number | undefined;
  reason?: string | undefined;
  versionId: number;
  workflow?: WorkflowDto | undefined;
  workflowStatus?: WorkflowStatusDto | undefined;
}

export interface ResourceListOfCategoryTextDto {
  elements?: CategoryTextDto[] | undefined;
  links?: Link[] | undefined;
}

export interface ResourceListOfCnrDto {
  elements?: CnrDto[] | undefined;
  links?: Link[] | undefined;
}

export interface ResourceListOfGroupDto {
  elements?: GroupDto[] | undefined;
  links?: Link[] | undefined;
}

export interface ResourceListOfProMTGroupDto {
    elements?: ProMTGroupDto[] | undefined;
    links?: Link[] | undefined;
}

export interface ResourceListOfImporterDto {
  elements?: ImporterDto[] | undefined;
  links?: Link[] | undefined;
}

export interface ResourceListOfLanguageDto {
  elements?: LanguageDto[] | undefined;
  links?: Link[] | undefined;
}

export interface ResourceListOfModeltypeBasicDto {
  elements?: ModeltypeBasicDto[] | undefined;
  links?: Link[] | undefined;
}

export interface ResourceListOfModelyearDto {
  elements?: ModelyearDto[] | undefined;
  links?: Link[] | undefined;
}

export interface ResourceListOfOptionBasicDto {
  elements?: OptionBasicDto[] | undefined;
  links?: Link[] | undefined;
}

export interface ResourceListOfOptionDto {
  elements?: OptionDto[] | undefined;
  links?: Link[] | undefined;
}

export interface ResourceListOfPrivilegeDto {
  elements?: PrivilegeDto[] | undefined;
  links?: Link[] | undefined;
}

export interface ResourceListOfRoleDto {
  elements?: RoleDto[] | undefined;
  links?: Link[] | undefined;
}

export interface ResourceListOfFlagDto {
  elements?: FlagDto[] | undefined;
  links?: Link[] | undefined;
}

export interface ResourceListOfNewsDto {
  elements?: NewsDto[] | undefined;
  links?: Link[] | undefined;
}

export interface ResourceListOfFaqDto {
  elements?: FaqDto[] | undefined;
  links?: Link[] | undefined;
}

export interface ResourceListOfLanguageCnrDto {
  elements?: LanguageCnrDto[] | undefined;
  links?: Link[] | undefined;
}

export interface ResourceListOfCategoryTextSortDto {
  elements?: CategoryTextSortDto[] | undefined;
  links?: Link[] | undefined;
}

export interface ResourceListOfSpecConfigurationDto {
  elements?: SpecConfigurationDto[] | undefined;
  links?: Link[] | undefined;
}

export interface ResourceListOfSpecDto {
  elements?: SpecDto[] | undefined;
  links?: Link[] | undefined;
}

export interface ResourceListOfTypefamilyDto {
  elements?: TypefamilyDto[] | undefined;
  links?: Link[] | undefined;
}

export interface ResourceListOfUserDto {
  elements?: UserDto[] | undefined;
  links?: Link[] | undefined;
}

export interface ResourceListOfWorkflowDto {
  elements?: WorkflowDto[] | undefined;
  links?: Link[] | undefined;
}

export interface ResourceListOfWorkflowOptionApprovalDto {
  elements?: WorkflowOptionApprovalDto[] | undefined;
  links?: Link[] | undefined;
}
export interface MaintenanceListDto {
  elements?: MaintenanceDto[] | undefined;
  links?: MenuDto
}
export interface MaintenanceDto {
 title:string;
 content:string;
 active:boolean;
 objectId?:number;
 versionId?:number;
 metadata?:Metadata;
}
export interface RoleDto {
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  name: string;
  objectId: number;
  privileges?: PrivilegeDto[] | undefined;
  versionId: number;
}

export interface FlagDto {
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  textLabel: string;
  objectId: number;
  versionId: number;
  optionsCount?: number;
}

export interface SimpleLanguageDto {
  code?: string | undefined;
  objectId?: number | undefined;
  nameDe?:string;
  nameEn?:string;
}

export interface SimpleOptionCopyDto {
  cnrId: number;
  modeltypeBasicAssignments?: AssignedModeltypeBasicDto[] | undefined;
  optionId: number;
}

export interface SimpleOptionDto {
  objectId?: number | undefined;
}

export interface SpecConfigurationDto {
  cnrId?: number | undefined;
  importerId?: number | undefined;
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  modeltypebasicId?: number | undefined;
  modelyearId: number;
  objectId: number;
  specs: string[];
  typefamilyId?: number | undefined;
  versionId: number;
}

export interface SpecDto {
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  objectId: number;
  specCategory: SpecDtoSpecCategory;
  specCode: string;
  versionId: number;
}

export interface SpecificOptionInitDto {
  baseMarketOptions?: number[] | undefined;
  cnrId?: number | undefined;
  specificType?: SpecificOptionInitDtoSpecificType | undefined;
}

export interface TechnicalDataDto {
  approvedStatus?: string | undefined;
  assignedGroup?: string | undefined;
  furtherSpecs?: string | undefined;
  gear?: string | undefined;
  group?: string | undefined;
  lastChange?: string | undefined;
  objectId?: number | undefined;
  pccdTechName?: string | undefined;
  pt3TechId?: string | undefined;
  salesName?: string | undefined;
  source?: string | undefined;
  techUnit?: string | undefined;
  techValue?: string | undefined;
  typification?: string | undefined;
}

export interface TextPartition {
  footer?: string | undefined;
  language?: string | undefined;
  longText?: string | undefined;
  shortText?: string | undefined;
  usp?: string | undefined;
}

export interface TypeCodeDto {
  code?: string | undefined;
  promtId?: string | undefined;
  type?: string | undefined;
}

export interface TypefamilyDto {
  hasPSLAssigned?: boolean | undefined;
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  modelyear?: ModelyearDto | undefined;
  name: string;
  objectId: number;
  sortSequence?: number | undefined;
  typefamily: string;
  versionId: number;
  key: string;
}

export interface TypefamilyExtDto {
  modelyear?: string | undefined;
  name?: string | undefined;
  promtId?: string | undefined;
  typefamily?: string | undefined;
}

export interface UserDetailsDto {
  cn?: string | undefined;
  department?: string | undefined;
  displayName?: string | undefined;
  email?: string | undefined;
  groups?: string[] | undefined;
  lastLogin?: number | undefined;
  privileges?: PrivilegeDto[] | undefined;
  representedUsers?: string[] | undefined;
  cnrs?: ResourceListOfCnrDto | undefined;
  modelyears?: ResourceListOfModelyearDto | undefined;
  typefamilies?: { [key: string]: ResourceListOfTypefamilyDto } | undefined;
}

export interface UserDto {
  assignedRoles?: AssignedUserRoleDto[] | undefined;
  cn: string;
  deputy?: UserDto | undefined;
  lastLogin?: number | undefined;
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  objectId: number;
  optionTypes?: OptionTypes[] | undefined;
  userSettings?: string | undefined;
  versionId: number;
  name?:string;
  department?:string;
}
export interface UserSettingsDto {
  email?: string | undefined;
  department?: string | undefined;
}

export interface VersionInfoDto {
  activeProfiles?: string[] | undefined;
  artifact?: string | undefined;
  group?: string | undefined;
  name?: string | undefined;
  time?: number | undefined;
  version?: string | undefined;
}

export interface View {
  contentType?: string | undefined;
}

export interface WorkflowDto {
  active?: string | undefined;
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  name: string;
  objectId: number;
  optionTypes?: string | undefined;
  partition: WorkflowDtoPartition;
  resetPointRejection?: boolean | undefined;
  resetRoles?: RoleDto[] | undefined;
  status?: WorkflowStatusDto[] | undefined;
  type: WorkflowDtoType;
  typefamilies?: string | undefined;
  versionId: number;
}

export interface WorkflowOptionApprovalDto {
  approved?: boolean | undefined;
  assignedModeltypes?: AssignedModeltypeBasicDto[] | undefined;
  basicTexts?: TextPartition[] | undefined;
  cnr: CnrDto;
  currentWorkflowStatus: WorkflowStatusDto;
  importer: ImporterDto;
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  modelyear: ModelyearDto;
  nextWorkflowStatus: WorkflowStatusDto;
  objectId: number;
  optionCode: string;
  optionComment?: string | undefined;
  optionId: number;
  optionType: WorkflowOptionApprovalDtoOptionType;
  optionVersion: number;
  partNumber?: string | undefined;
  rejectMessage?: string | undefined;
  prevRejectMessage?: string | undefined;
  requestingRole: RoleDto;
  typefamily: TypefamilyDto;
  versionId: number;
  workflow: WorkflowDto;
  parentApprovedTimestamp:number;
  parentModelyear:string;
  firstApproval:boolean;
  parentTexts:TextPartition[];
  isTextsChanged:boolean;
  isAssignmentChanged:boolean;

}

export interface OptionPreviousApprovalHistoryDto {
  changedBy: string;
  changedTimestamp: number;
  texts: TextPartition[];
  assignments: AssignedModeltypeBasicDto[];
  lastWorkflowStep:boolean;
  rejectedBefore:boolean;
  resetBefore:boolean;
}

export interface WorkflowStatusDto {
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  name: string;
  objectId: number;
  resetPoint: boolean;
  role: RoleDto;
  sequenceNumber: number;
  type: WorkflowStatusDtoType;
  versionId: number;
  workflow: WorkflowDto;
}

export interface HistoryDto {
    changedBy: string;
    changedTimestamp: number;
    fieldKey: string;
    previousValue: string | null;
    newValue: string | null;
    newlyCreatedFlag: boolean;
}

export interface MissingAssignmentsAndDerivateDTO {
  missingPCCDAssignments: { [key: string]: string[] };
  missingPCCDDerivates: { [key: string]: string[] };
  pccdNoDataDerivatesAssignments: { [key: string]: string[] };
  pccdNoDataAssignments: { [key: string]: string[] };
  pccdNoDataDerivates:boolean;
}


/** workflowType */
export enum WorkflowType {
  OPTION_BASIC = 'OPTION_BASIC',
  OPTION_PARTITION = 'OPTION_PARTITION',
}

export enum Anonymous {
  M = 'M',
  EXC = 'EXC',
  PKG = 'PKG',
  EPKG = 'EPKG',
  CT = 'CT',
  Z = 'Z',
  F = 'F',
  I = 'I',
  TEQ = 'TEQ',
  SER = 'SER',
}

export enum AssignedModeltypeBasicDtoAssignmentType {
  N = 'N',
  S = 'S',
  O = 'O',
  W = 'W',
  SE = 'SE',
  OE = 'OE',
  WE = 'WE',
  OF = 'OF',
  SV = 'SV',
  SS = 'SS',
  SG = 'SG',
  SB = 'SB',
  SC = 'SC',
}

export enum ExcelVisibleColumns {
  HEADER_TITLE_EN = 'HEADER_TITLE_EN',
  HEADER_TITLE_DE = 'HEADER_TITLE_DE',
  HEADER_TIMESTAMP = 'HEADER_TIMESTAMP',
  HEADER_CONTEXT = 'HEADER_CONTEXT',
  S = 'S',
  O = 'O',
  W = 'W',
  N = 'N',
  CATEGORY = 'CATEGORY',
  MODELTYPEBASIC = 'MODELTYPEBASIC',
  BM_INHERITED_OPTION_FLAG = 'BM_INHERITED_OPTION_FLAG',
  EXCLUSIVE_OPTION_FLAG = 'EXCLUSIVE_OPTION_FLAG',
  OPTION_CODE = 'OPTION_CODE',
  OPTION_TYPE = 'OPTION_TYPE',
  WORKFLOW = 'WORKFLOW',
  SHORTTEXT_EN = 'SHORTTEXT_EN',
  SHORTTEXT_DE = 'SHORTTEXT_DE',
  LONGTEXT_EN = 'LONGTEXT_EN',
  LONGTEXT_DE = 'LONGTEXT_DE',
  FOOTER_EN = 'FOOTER_EN',
  FOOTER_DE = 'FOOTER_DE',
  USP_EN = 'USP_EN',
  USP_DE = 'USP_DE',
  COMMENT = 'COMMENT',
  AVAILABLE_START = 'AVAILABLE_START',
  AVAILABLE_END = 'AVAILABLE_END',
  CONSTRAINT = 'CONSTRAINT',
  EXCLUSION = 'EXCLUSION',
  PACKAGE_CONTENT = 'PACKAGE_CONTENT',
  REFERENCE = 'REFERENCE',
  REFERENCE_EXC = 'REFERENCE_EXC',
  PRICE = 'PRICE',
  SEQUENCE = 'SEQUENCE',
  CATEGORY_HEADER = 'CATEGORY_HEADER',
  FLAGS = 'FLAGS',
  PDIP_TEXT='PDIP_TEXT'
}

export enum ModelAndViewStatus {
  _100 = '100',
  _101 = '101',
  _102 = '102',
  _103 = '103',
  _200 = '200',
  _201 = '201',
  _202 = '202',
  _203 = '203',
  _204 = '204',
  _205 = '205',
  _206 = '206',
  _207 = '207',
  _208 = '208',
  _226 = '226',
  _300 = '300',
  _301 = '301',
  _302 = '302',
  _303 = '303',
  _304 = '304',
  _305 = '305',
  _307 = '307',
  _308 = '308',
  _400 = '400',
  _401 = '401',
  _402 = '402',
  _403 = '403',
  _404 = '404',
  _405 = '405',
  _406 = '406',
  _407 = '407',
  _408 = '408',
  _409 = '409',
  _410 = '410',
  _411 = '411',
  _412 = '412',
  _413 = '413',
  _414 = '414',
  _415 = '415',
  _416 = '416',
  _417 = '417',
  _418 = '418',
  _419 = '419',
  _420 = '420',
  _421 = '421',
  _422 = '422',
  _423 = '423',
  _424 = '424',
  _426 = '426',
  _428 = '428',
  _429 = '429',
  _431 = '431',
  _451 = '451',
  _500 = '500',
  _501 = '501',
  _502 = '502',
  _503 = '503',
  _504 = '504',
  _505 = '505',
  _506 = '506',
  _507 = '507',
  _508 = '508',
  _509 = '509',
  _510 = '510',
  _511 = '511',
}

export enum OptionBasicCoreDtoOptionType {
  M = 'M',
  EXC = 'EXC',
  PKG = 'PKG',
  EPKG = 'EPKG',
  CT = 'CT',
  Z = 'Z',
  F = 'F',
  I = 'I',
  TEQ = 'TEQ',
  SER = 'SER',
}

export enum OptionBasicDtoOptionType {
  M = 'M',
  EXC = 'EXC',
  PKG = 'PKG',
  EPKG = 'EPKG',
  CT = 'CT',
  Z = 'Z',
  F = 'F',
  I = 'I',
  TEQ = 'TEQ',
  SER = 'SER',
}

export enum OptionBasicDtoTextExportStatus {
  OB_NOT_APPROVED = 'OB_NOT_APPROVED',
  SER_OPTION_TYPE = 'SER_OPTION_TYPE',
  TEQ_OPTION_TYPE = 'TEQ_OPTION_TYPE',
  NO_PCCD_TEXT = 'NO_PCCD_TEXT',
  NO_PCCD_GENERAL_TEXT = 'NO_PCCD_GENERAL_TEXT',
  OB_EXPORT_SUCCESS = 'OB_EXPORT_SUCCESS',
  OB_PCCD_EXPORT_ERROR = 'OB_PCCD_EXPORT_ERROR',
  OB_DUPLICATE_PCCD_IDENTIFIER = 'OB_DUPLICATE_PCCD_IDENTIFIER',
  O_DUPLICATE_PCCD_IDENTIFIER = 'O_DUPLICATE_PCCD_IDENTIFIER',
  O_NOT_APPROVED = 'O_NOT_APPROVED',
  NO_MB_VALID_ASSIGNMENT = 'NO_MB_VALID_ASSIGNMENT',
  O_EXPORT_SUCCESS = 'O_EXPORT_SUCCESS',
  O_PCCD_EXPORT_ERROR = 'O_PCCD_EXPORT_ERROR',
  OB_NOT_APPROVED_O_EXPORTED = 'OB_NOT_APPROVED_O_EXPORTED',
  OB_O_TEXTS_IDENTICAL = 'OB_O_TEXTS_IDENTICAL',
  PCCD_PROMT_IDENTICAL = 'PCCD_PROMT_IDENTICAL',
  OUT_OF_RANGE_MODELYEAR = 'OUT_OF_RANGE_MODELYEAR',
  INVALID_EXPORT_MARKET = 'INVALID_EXPORT_MARKET',
  PENDING_DELIVERY_PROCESSING = 'PENDING_DELIVERY_PROCESSING',
  PROMT_OB_ERROR = 'PROMT_OB_ERROR',
  PROMT_O_ERROR = 'PROMT_O_ERROR',
  UNKNOWN_PCCD_BTYP = 'UNKNOWN_PCCD_BTYP',
}


export enum ModeltypeBasicExportStatus {
  DERIVATE_PCCD_EXPORT_SUCCESS='DERIVATE_PCCD_EXPORT_SUCCESS',
  DERIVATE_NO_PCCD_TEXT='DERIVATE_NO_PCCD_TEXT',
  DERIVATE_EXPORT_PENDING='DERIVATE_EXPORT_PENDING',
  DERIVATE_PCCD_IDENTICAL='DERIVATE_PCCD_IDENTICAL',
  DERIVATE_PCCD_EXPORT_ERROR='DERIVATE_PCCD_EXPORT_ERROR'
}
export enum ErrorStatus {
  ERROR_BAD_REQUEST = 'ERROR_BAD_REQUEST',
  ERROR_UNAUTHORIZED = 'ERROR_UNAUTHORIZED',
  ERROR_FORBIDDEN = 'ERROR_FORBIDDEN',
  INTERNAL_SERVER_ERROR = 'INTERNAL_SERVER_ERROR',
  NO_TRANSLATED_DATA = 'NO_TRANSLATED_DATA'
}

export enum OptionBasicSimpleDtoOptionType {
  M = 'M',
  EXC = 'EXC',
  PKG = 'PKG',
  EPKG = 'EPKG',
  CT = 'CT',
  Z = 'Z',
  F = 'F',
  I = 'I',
  TEQ = 'TEQ',
  SER = 'SER',
}

export enum OptionDifferenceDtoOptionType {
  M = 'M',
  EXC = 'EXC',
  PKG = 'PKG',
  EPKG = 'EPKG',
  CT = 'CT',
  Z = 'Z',
  F = 'F',
  I = 'I',
  TEQ = 'TEQ',
  SER = 'SER',
}

export enum OptionDtoSpecificType {
  DEPENDENT_OVERWRITE = 'DEPENDENT_OVERWRITE',
  INDEPENDENT_OVERWRITE = 'INDEPENDENT_OVERWRITE',
  COPY = 'COPY',
  NON_SPECIFIC = 'NON_SPECIFIC',
}

export enum OptionDtoTextExportStatus {
  OB_NOT_APPROVED = 'OB_NOT_APPROVED',
  SER_OPTION_TYPE = 'SER_OPTION_TYPE',
  TEQ_OPTION_TYPE = 'TEQ_OPTION_TYPE',
  NO_PCCD_TEXT = 'NO_PCCD_TEXT',
  NO_PCCD_GENERAL_TEXT = 'NO_PCCD_GENERAL_TEXT',
  OB_EXPORT_SUCCESS = 'OB_EXPORT_SUCCESS',
  OB_PCCD_EXPORT_ERROR = 'OB_PCCD_EXPORT_ERROR',
  OB_DUPLICATE_PCCD_IDENTIFIER = 'OB_DUPLICATE_PCCD_IDENTIFIER',
  O_DUPLICATE_PCCD_IDENTIFIER = 'O_DUPLICATE_PCCD_IDENTIFIER',
  O_NOT_APPROVED = 'O_NOT_APPROVED',
  NO_MB_VALID_ASSIGNMENT = 'NO_MB_VALID_ASSIGNMENT',
  O_EXPORT_SUCCESS = 'O_EXPORT_SUCCESS',
  O_PCCD_EXPORT_ERROR = 'O_PCCD_EXPORT_ERROR',
  OB_O_TEXTS_IDENTICAL = 'OB_O_TEXTS_IDENTICAL',
  PCCD_PROMT_IDENTICAL = 'PCCD_PROMT_IDENTICAL',
  OUT_OF_RANGE_MODELYEAR = 'OUT_OF_RANGE_MODELYEAR',
  INVALID_EXPORT_MARKET = 'INVALID_EXPORT_MARKET',
  PENDING_DELIVERY_PROCESSING = 'PENDING_DELIVERY_PROCESSING',
  PROMT_OB_ERROR = 'PROMT_OB_ERROR',
  PROMT_O_ERROR = 'PROMT_O_ERROR',
  UNKNOWN_PCCD_BTYP = 'UNKNOWN_PCCD_BTYP',
}

export enum OptionWorkflowStatusDifferenceDtoType {
  MAINTENANCE = 'MAINTENANCE',
  APPROVAL = 'APPROVAL',
  APPROVED = 'APPROVED',
  FREEZE = 'FREEZE',
  REJECTED = 'REJECTED',
}

export enum OptionWorkflowStatusMultiUpdateParamActionType {
  RESET = 'RESET',
  MOVE_FORWARD = 'MOVE_FORWARD',
}

export enum OptionFlagMultiUpdateParamActionType {
  ADD = 'ADD',
  REMOVE = 'REMOVE',
}
export enum PSLCopyConflictDtoOptionType {
  M = 'M',
  EXC = 'EXC',
  PKG = 'PKG',
  EPKG = 'EPKG',
  CT = 'CT',
  Z = 'Z',
  F = 'F',
  I = 'I',
  TEQ = 'TEQ',
  SER = 'SER',
}

export enum SpecDtoSpecCategory {
  ABGAS = 'ABGAS',
  REST = 'REST',
}

export enum SpecificOptionInitDtoSpecificType {
  DEPENDENT_OVERWRITE = 'DEPENDENT_OVERWRITE',
  INDEPENDENT_OVERWRITE = 'INDEPENDENT_OVERWRITE',
  COPY = 'COPY',
  NON_SPECIFIC = 'NON_SPECIFIC',
}

export enum OptionTypes {
  M = 'M',
  EXC = 'EXC',
  PKG = 'PKG',
  EPKG = 'EPKG',
  CT = 'CT',
  Z = 'Z',
  F = 'F',
  I = 'I',
  TEQ = 'TEQ',
  SER = 'SER',
}

export enum WorkflowDtoPartition {
  BASIC_TEXTS = 'BASIC_TEXTS',
  INTERNAL_TEXTS = 'INTERNAL_TEXTS',
  TECHNICAL_DESC = 'TECHNICAL_DESC',
  MODELTYPES = 'MODELTYPES',
  ALL = 'ALL',
  KUMA_TEXTS='KUMA_TEXTS'
}

export enum WorkflowDtoType {
  OPTION_BASIC = 'OPTION_BASIC',
  OPTION_PARTITION = 'OPTION_PARTITION',
  KUMA='KUMA'
}

export enum WorkflowOptionApprovalDtoOptionType {
  M = 'M',
  EXC = 'EXC',
  PKG = 'PKG',
  EPKG = 'EPKG',
  CT = 'CT',
  Z = 'Z',
  F = 'F',
  I = 'I',
  TEQ = 'TEQ',
  SER = 'SER',
}

export enum WorkflowStatusDtoType {
  MAINTENANCE = 'MAINTENANCE',
  APPROVAL = 'APPROVAL',
  APPROVED = 'APPROVED',
  FREEZE = 'FREEZE',
  REJECTED = 'REJECTED',
  TRANSLATION = 'TRANSLATION',
}

export enum ENewsPriority {
  INFO = 'INFO',
  HIGH = 'HIGH',
}

export class SwaggerResponse<TResult> {
  status: number;
  headers: { [key: string]: any };
  result: TResult;

  constructor(
    status: number,
    headers: { [key: string]: any },
    result: TResult
  ) {
    this.status = status;
    this.headers = headers;
    this.result = result;
  }
}

export class SwaggerException extends Error {
  message: string;
  status: number;
  response: string;
  headers: { [key: string]: any };
  result: any;

  constructor(
    message: string,
    status: number,
    response: string,
    headers: { [key: string]: any },
    result: any
  ) {
    super();

    this.message = message;
    this.status = status;
    this.response = response;
    this.headers = headers;
    this.result = result;
  }

  protected isSwaggerException = true;

  static isSwaggerException(obj: any): obj is SwaggerException {
    return obj.isSwaggerException === true;
  }
}

function throwException(
  message: string,
  status: number,
  response: string,
  headers: { [key: string]: any },
  result?: any
): any {
  if (result !== null && result !== undefined) throw result;
  else throw new SwaggerException(message, status, response, headers, null);
}

export interface KumaViewDto {
  title?: string | undefined;
  regions: RegionDto[];
  assignedCnrs: CnrDto[];
  links?: Link[] | undefined;
  metadata?: Metadata | undefined;
  architectureSystems?:string | undefined;
  typefamilies: TypefamilyDto[];
  objectId: number;
  versionId: number;
  modelyears?: ModelyearDto[];
  detail?:string;
  active:boolean;
  votes:VoteDto[];
  status:string;
   /**
     * Human readable for of the workflow status.
     * Must be updated when the statusValueStatus changes
     */
   statusView?: string;
   /**
    * The value status of the row. If must exist as IStateProperty inside
    * statusValueStates. This is the objectId of the corresponding WorkflowStatusDto.
    */
   statusValueState?: number;

   /** The EditableValue for the current row status. */
   statusValueStateEditable?: EditableValue;

   /** Flag to check if the workflow can be set back to the first step */
   statusValueStateResetable?: boolean;

   /** Available value states for the current row. */
   statusValueStates: IStateProperty[];

   workflowType?: WorkflowDtoType;
   workFlowName: string;
   derivates: ModeltypeBasicDto[];
}
export interface RegionDto extends Metadata {
  objectId: number;
  versionId: number;
  name: string;
  id:number;
}
export interface KumaRegionListDto {
  elements?: RegionDto[] | undefined;
  links?: Link[] | undefined;
}
export interface KumaRequirementListDto {
  elements?: any;
  links: Link[];
}
export interface KumaCnrByRegionParams {
  regionIds: number[];
}
export interface KumaCnrListByRegion {
  elements?: CnrDto[] | undefined;
  links?: Link[] | undefined;
}
export interface VoteDto {
  requirementId:number;
  stars:number;
}
export interface TranslationServiceDto {
  service:string;
}
export interface OptionAWSTranslateDto {
    text?: string;
    service?: TranslationServiceEnum;
    sourceLanguage?: string;
    targetLanguage?: string;
    formality?: TranslationFormalityEnum;
    terminologyNames?: string[];
    objectId?:any;
}

export interface OptionAWSGrammarDto {
    text: string;
}
export interface OptionAWSSuggestionDto {
    text: string;
}

export enum TranslationServiceEnum {
    AWS_TRANSLATE = "AWS_TRANSLATE",
    AWS_BEDROCK = "AWS_BEDROCK"
}

// If TranslationFormalityEnum is not defined, define it like this:
export type TranslationFormalityEnum = 'FORMAL' | 'INFORMAL' | 'NEUTRAL'; // adjust values as needed



// WEBPACK FOOTER //
// ./src/services/Client.ts